import React, { useState, useEffect, useRef, useCallback } from 'react';
import { createClient } from '@supabase/supabase-js';
import ClearedLogomark from './ClearedLogomark';
import './App.css';
const SUPABASE_URL = 'https://hswitpdfkvpcljgqnaxe.supabase.co';
const SUPABASE_ANON_KEY = 'sb_publishable_t1vTwOuDv4oKayU1JEYHCQ_cu7zYn-k';
export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);
const QUOTES = [
  "You don't have to do it all. Just what matters.",
  "Rest is part of the plan, not a break from it.",
  "Small steps still move mountains.",
  "You're doing more than you know.",
  "The invisible work you do is real. It counts.",
  "Today's enough. You're enough.",
  "Progress, not perfect. Always.",
  "You showed up. That's everything."
];

const CELEBRATIONS = [
  { msg: "You did that.", sub: "One less thing on your plate." },
  { msg: "Cleared.", sub: "That's the energy. Keep going." },
  { msg: "Look at you go.", sub: "Every check counts. Every single one." },
  { msg: "Done.", sub: "You made it happen. That's all you." },
  { msg: "One more off the list.", sub: "Still here. Still clearing." },
  { msg: "Be proud.", sub: "You handled it." }
];

const QUADRANTS = [
  { key: 'do', label: 'Do Right Now', color: 'coral' },
  { key: 'schedule', label: 'Call & Schedule', color: 'teal' },
  { key: 'delegate', label: 'Shop & Errands', color: 'gold', hasGrocery: true },
  { key: 'let', label: 'Do at Home', color: 'plum' },
];

const THEMES = {
  deepsea: {
    label: 'Deep Sea',
    bodyBg: '#F1FAEE',
    cardBg: '#FFFFFF',
    text: '#1D3557',
    subtext: '#3D6080',
    colors: {
      coral: { bg:'#1D3557', border:'#0E1A2C', dark:'#F1FAEE', main:'#1D3557' },
      teal:  { bg:'#457B9D', border:'#1E3D50', dark:'#E0EAF2', main:'#457B9D' },
      gold:  { bg:'#A8DADC', border:'#3A7A7D', dark:'#1D3557', main:'#A8DADC' },
      plum:  { bg:'#F1FAEE', border:'#A8DADC', dark:'#1D3557', main:'#F1FAEE' },
    },
    habits: ['#1D3557','#457B9D','#A8DADC','#F1FAEE','#2A4A72','#6AABB0'],
  },
  daylily: {
    label: 'Daylily',
    bodyBg: '#F8FAF6',
    cardBg: '#FFFFFF',
    text: '#1A2B22',
    subtext: '#5F7068',
    colors: {
      coral: { bg:'#E8A1B0', border:'#8B3A4A', dark:'#FFFFFF', main:'#E8A1B0' },
      teal:  { bg:'#9BA4E0', border:'#3A3D6B', dark:'#FFFFFF', main:'#9BA4E0' },
      gold:  { bg:'#6DCCAE', border:'#1E5C44', dark:'#FFFFFF', main:'#6DCCAE' },
      plum:  { bg:'#2A3A5C', border:'#0B1629', dark:'#FFFFFF', main:'#2A3A5C' },
    },
    habits: ['#E8A1B0','#9BA4E0','#6DCCAE','#2A3A5C','#D4695A','#7B8AD0'],
  },
  sunset: {
    label: 'Sunset Terracotta',
    bodyBg: '#FDF5EE',
    cardBg: '#FFFFFF',
    text: '#3A1E10',
    subtext: '#7A5A42',
    colors: {
      coral: { bg:'#C65D3C', border:'#6A2E1C', dark:'#FFFFFF', main:'#C65D3C' },
      teal:  { bg:'#E09F7D', border:'#7A4E34', dark:'#3A1E10', main:'#E09F7D' },
      gold:  { bg:'#A04A2A', border:'#502412', dark:'#FFFFFF', main:'#A04A2A' },
      plum:  { bg:'#F2C79E', border:'#8A6830', dark:'#3A1E10', main:'#F2C79E' },
    },
    habits: ['#C65D3C','#E09F7D','#A04A2A','#F2C79E','#D88050','#C4A070'],
  },
  powder: {
    label: 'Powder Blue',
    bodyBg: '#F4F8FB',
    cardBg: '#FFFFFF',
    text: '#2A3E50',
    subtext: '#6A7E90',
    colors: {
      coral: { bg:'#B8D8E8', border:'#4A7A94', dark:'#2A3E50', main:'#B8D8E8' },
      teal:  { bg:'#E3F2FD', border:'#5A8AAA', dark:'#2A3E50', main:'#E3F2FD' },
      gold:  { bg:'#7FA8C9', border:'#2E5474', dark:'#FFFFFF', main:'#7FA8C9' },
      plum:  { bg:'#E8A1B0', border:'#8B3A4A', dark:'#FFFFFF', main:'#E8A1B0' },
    },
    habits: ['#B8D8E8','#E3F2FD','#7FA8C9','#E8A1B0','#8CC0D8','#C4B0B0'],
  },
  peach: {
    label: '✨ Peach Sorbet',
    bodyBg: '#FAF7F2',
    cardBg: '#FFFFFF',
    text: '#3A1E10',
    subtext: '#7A5A42',
    colors: {
      coral: { bg:'#E76F51', border:'#7A3422', dark:'#FFFFFF', main:'#E76F51' },
      teal:  { bg:'#F4A261', border:'#7A4A1E', dark:'#3A1E10', main:'#F4A261' },
      gold:  { bg:'#FFE4D6', border:'#C4906A', dark:'#3A1E10', main:'#FFE4D6' },
      plum:  { bg:'#87A878', border:'#3E5A2E', dark:'#FFFFFF', main:'#87A878' },
    },
    habits: ['#E76F51','#F4A261','#FFE4D6','#87A878','#D88050','#A0C090'],
  },
  poppy: {
    label: '✨ Poppy Fields',
    bodyBg: '#FDF6F0',
    cardBg: '#FFFFFF',
    text: '#2A1A12',
    subtext: '#6A4A3A',
    colors: {
      coral: { bg:'#D86670', border:'#6A2830', dark:'#FFFFFF', main:'#D86670' },
      teal:  { bg:'#F0B584', border:'#7A5230', dark:'#2A1A12', main:'#F0B584' },
      gold:  { bg:'#E89580', border:'#7A3E30', dark:'#FFFFFF', main:'#E89580' },
      plum:  { bg:'#5BB3A4', border:'#245A50', dark:'#FFFFFF', main:'#5BB3A4' },
    },
    habits: ['#D86670','#F0B584','#E89580','#5BB3A4','#E08888','#80CCC0'],
  },
  electric: {
    label: '✨ Electric Dream',
    bodyBg: '#F0FAFD',
    cardBg: '#FFFFFF',
    text: '#0A3050',
    subtext: '#3A6A8A',
    colors: {
      coral: { bg:'#00B4D8', border:'#005A6C', dark:'#FFFFFF', main:'#00B4D8' },
      teal:  { bg:'#90E0EF', border:'#2A7A8E', dark:'#0A3050', main:'#90E0EF' },
      gold:  { bg:'#0077B6', border:'#003A5A', dark:'#FFFFFF', main:'#0077B6' },
      plum:  { bg:'#CAF0F8', border:'#3A8A9A', dark:'#0A3050', main:'#CAF0F8' },
    },
    habits: ['#00B4D8','#90E0EF','#0077B6','#CAF0F8','#40C8E0','#60D0F0'],
  },
  tropical: {
    label: '✨ Tropical Retreat',
    bodyBg: '#F2FBF9',
    cardBg: '#FFFFFF',
    text: '#1A3A32',
    subtext: '#4A7A6A',
    colors: {
      coral: { bg:'#2EC4B6', border:'#14625A', dark:'#FFFFFF', main:'#2EC4B6' },
      teal:  { bg:'#CBF3F0', border:'#3A8A80', dark:'#1A3A32', main:'#CBF3F0' },
      gold:  { bg:'#FFBF69', border:'#7A5A1A', dark:'#1A3A32', main:'#FFBF69' },
      plum:  { bg:'#FFFFFF', border:'#E0E0E0', dark:'#6A6A6A', main:'#FFFFFF' },
    },
    habits: ['#2EC4B6','#CBF3F0','#FFBF69','#C0C0C0','#50D4C6','#FFD490'],
  },
};

function getReadableTextColor(hex) {
  const h = hex.replace('#','');
  const r = parseInt(h.substring(0,2),16);
  const g = parseInt(h.substring(2,4),16);
  const b = parseInt(h.substring(4,6),16);
  const lum = (r * 0.299 + g * 0.587 + b * 0.114) / 255;
  return lum > 0.62 ? '#2D2D2D' : '#F5F5F5';
}

let COLOR = THEMES.deepsea.colors;
let HABIT_COLORS = THEMES.deepsea.habits;
let THEME = THEMES.deepsea;
function applyTheme(name) {
  const t = THEMES[name] || THEMES.deepsea;
  COLOR = t.colors;
  HABIT_COLORS = t.habits;
  THEME = t;
}
try { const saved = localStorage.getItem('clearedTheme'); if (saved && THEMES[saved]) applyTheme(saved); } catch(e) {}

function randomFrom(arr) { return arr[Math.floor(Math.random() * arr.length)]; }

function useCountdown(leaveTime) {
  const [display, setDisplay] = useState('');
  const [status, setStatus] = useState('green');
  const [statusMsg, setStatusMsg] = useState('');
  useEffect(() => {
    function calc() {
      if (!leaveTime) return;
      const [lh, lm] = leaveTime.split(':').map(Number);
      const now = new Date();
      const leave = new Date();
      leave.setHours(lh, lm, 0, 0);
      let diffMs = leave - now;
      if (diffMs < 0) {
        // If leave time is more than 2 hours ago, assume they mean tomorrow
        if (diffMs < -2 * 60 * 60 * 1000) {
          leave.setDate(leave.getDate() + 1);
          diffMs = leave - now;
        } else {
          // Recently passed — show "Go!"
          setDisplay("Go!"); setStatus('red'); setStatusMsg("It's time to leave — out the door!");
          return;
        }
      }
      const totalMins = Math.floor(diffMs / 60000);
      const hrs = Math.floor(totalMins / 60);
      const mins = totalMins % 60;
      setDisplay(hrs > 0 ? `${hrs}:${String(mins).padStart(2,'0')}` : `${mins}m`);
      if (totalMins > 45) { setStatus('green'); setStatusMsg("You're on track — keep it up!"); }
      else if (totalMins > 20) { setStatus('amber'); setStatusMsg("Start wrapping up — time is moving."); }
      else { setStatus('red'); setStatusMsg("Almost time — finish up and head out!"); }
    }
    calc();
    const t = setInterval(calc, 30000);
    return () => clearInterval(t);
  }, [leaveTime]);
  return { display, status, statusMsg };
}

function MorningCommandCenter({ onDismiss, userId, profile, onProfileChange }) {
  const [items, setItems] = useState(() => {
    try { const s = localStorage.getItem('morningItems'); if (s) return JSON.parse(s); } catch(e) {}
    if (profile?.morning_items?.length) return profile.morning_items.map(i => ({...i, done:false}));
    return [];
  });
  const [leaveTime, setLeaveTime] = useState(() => profile?.leave_time || localStorage.getItem('clearedLeaveTime') || '08:00');
  const [newItem, setNewItem] = useState('');
  const { display, status, statusMsg } = useCountdown(leaveTime);
  const done = items.filter(i => i.done).length;
  const pct = items.length === 0 ? 0 : Math.round((done / items.length) * 100);
  const toggle = (id) => setItems(prev => {
    const next = prev.map(i => i.id === id ? {...i, done:!i.done} : i);
    localStorage.setItem('morningItems', JSON.stringify(next));
    return next;
  });
  const saveProfile = useCallback(async (morningItems, lt) => {
    localStorage.setItem('morningItems', JSON.stringify(morningItems));
    const toSave = morningItems.map(({done, ...rest}) => rest);
    if (!userId) return;
    const updates = { user_id: userId, morning_items: toSave, leave_time: lt };
    await supabase.from('profile').upsert(updates, { onConflict: 'user_id' });
    if (onProfileChange) onProfileChange({ ...profile, morning_items: toSave, leave_time: lt });
  }, [userId, profile, onProfileChange]);
  const addItem = () => {
    if (!newItem.trim()) return;
    const updated = [...items, { id:Date.now(), text:newItem.trim(), tag:'self', color:'plum', done:false }];
    setItems(updated);
    setNewItem('');
    saveProfile(updated, leaveTime);
  };
  const handleLeaveTimeChange = (val) => {
    setLeaveTime(val);
    localStorage.setItem('clearedLeaveTime', val);
    saveProfile(items, val);
  };
  const [removedItem, setRemovedItem] = useState(null);
  const [undoTimer, setUndoTimer] = useState(null);
  const removeItem = (id) => {
    const item = items.find(i => i.id === id);
    const updated = items.filter(i => i.id !== id);
    setItems(updated);
    saveProfile(updated, leaveTime);
    if (item) {
      setRemovedItem(item);
      if (undoTimer) clearTimeout(undoTimer);
      setUndoTimer(setTimeout(() => setRemovedItem(null), 4000));
    }
  };
  const undoRemove = () => {
    if (removedItem) {
      const restored = [...items, removedItem];
      setItems(restored);
      saveProfile(restored, leaveTime);
      setRemovedItem(null);
      if (undoTimer) clearTimeout(undoTimer);
    }
  };
  const editItem = (id, newText) => {
    const updated = items.map(i => i.id === id ? {...i, text: newText} : i);
    setItems(updated);
    saveProfile(updated, leaveTime);
  };
  const resetChecklist = () => {
    const reset = items.map(i => ({...i, done: false}));
    setItems(reset);
    localStorage.setItem('morningItems', JSON.stringify(reset));
  };
  const [editingId, setEditingId] = useState(null);
  const [editText, setEditText] = useState('');
  const [dragIdx, setDragIdx] = useState(null);
  const reorderItems = (from, to) => {
    const arr = [...items];
    const [moved] = arr.splice(from, 1);
    arr.splice(to, 0, moved);
    setItems(arr);
    localStorage.setItem('morningItems', JSON.stringify(arr));
  };
  const sc = { green:{bg:'#E4F0EE',color:'#2D6B60',dot:'#5B9E8F'}, amber:{bg:'#F5EDDF',color:'#7A5A28',dot:'#C4985A'}, red:{bg:'#F5E8E6',color:'#8B3A2E',dot:'#D4695A'} }[status];

  return (
    <div style={{background:'#FAF7F2', minHeight:'100vh', paddingTop:'1rem'}}>
      <div style={{padding:'0 1.5rem 1rem', display:'flex', justifyContent:'space-between', alignItems:'center'}}>
        <div onClick={onDismiss} style={{fontFamily:"'Cormorant Garamond',serif", fontSize:'1.4rem', fontWeight:600, letterSpacing:'0.04em', cursor:'pointer', transition:'opacity 0.2s'}} onMouseEnter={e=>e.target.style.opacity='0.7'} onMouseLeave={e=>e.target.style.opacity='1'}>Cleared<span style={{color:'#D4695A'}}>.</span></div>
        <button onClick={onDismiss} style={{background:'#D4695A', color:'white', border:'none', borderRadius:50, padding:'0.4rem 1rem', fontFamily:'Outfit,sans-serif', fontSize:'0.72rem', fontWeight:500, cursor:'pointer'}}>Back to my day</button>
      </div>
      <div style={{padding:'0 1.5rem', maxWidth:480, margin:'0 auto'}}>
        <div style={{fontFamily:"'Cormorant Garamond',serif", fontSize:'2rem', fontWeight:600, color:THEME.text, lineHeight:1.1, marginBottom:'1.5rem'}}>Let's get<br/>your day ready.</div>

        <div style={{background:THEME.cardBg, borderRadius:20, border:'1px solid rgba(128,128,128,0.15)', padding:'1.25rem 1.5rem', marginBottom:'1.25rem', display:'flex', alignItems:'center', justifyContent:'space-between', gap:12}}>
          <div>
            <div style={{fontSize:'0.65rem', fontWeight:600, letterSpacing:'0.12em', textTransform:'uppercase', color:THEME.subtext, marginBottom:2}}>Time until you leave</div>
            <div style={{fontFamily:"'Cormorant Garamond',serif", fontSize:'3rem', fontWeight:600, lineHeight:1, color:'#D4695A'}}>{display}</div>
            <div style={{fontSize:'0.72rem', color:THEME.subtext, marginTop:2}}>{display==='Go!' ? 'time to leave!' : display.includes(':') ? "hr min — you've got this" : 'minutes remaining'}</div>
          </div>
          <div style={{textAlign:'right'}}>
            <div style={{fontSize:'0.6rem', fontWeight:600, letterSpacing:'0.1em', textTransform:'uppercase', color:THEME.subtext, marginBottom:4}}>Leave at</div>
            <input type="time" value={leaveTime} onChange={e=>handleLeaveTimeChange(e.target.value)} style={{fontFamily:"'Cormorant Garamond',serif", fontSize:'1.4rem', fontWeight:600, color:THEME.text, border:'none', background:'none', textAlign:'right', outline:'none', width:100, cursor:'pointer'}}/>
          </div>
        </div>

        <div style={{display:'flex', alignItems:'center', gap:8, padding:'0.6rem 1rem', borderRadius:10, marginBottom:'1.25rem', background:sc.bg, color:sc.color, fontSize:'0.78rem', fontWeight:500}}>
          <div style={{width:8, height:8, borderRadius:'50%', background:sc.dot, flexShrink:0}}/>{statusMsg}
        </div>

        <div style={{fontSize:'0.6rem', fontWeight:600, letterSpacing:'0.14em', textTransform:'uppercase', color:THEME.subtext, marginBottom:'0.75rem'}}>Your morning checklist</div>

        {items.length > 0 && (
          <div style={{marginBottom:'1.25rem'}}>
            <div style={{height:6, background:'rgba(128,128,128,0.15)', borderRadius:50, overflow:'hidden', marginBottom:5}}>
              <div style={{height:'100%', width:`${pct}%`, background:pct===100?'#5B9E8F':'#D4695A', borderRadius:50, transition:'width 0.4s ease'}}/>
            </div>
            <div style={{display:'flex', justifyContent:'space-between', fontSize:'0.68rem', color:THEME.subtext}}>
              <span>{done} of {items.length} done</span><span>{pct}%</span>
            </div>
          </div>
        )}

        <div style={{display:'flex', flexDirection:'column', gap:8, marginBottom:'1.25rem'}}>
          {items.map((item,idx) => (
            <div key={item.id} draggable={editingId!==item.id} onDragStart={()=>setDragIdx(idx)} onDragEnd={()=>setDragIdx(null)} onDragOver={e=>e.preventDefault()} onDrop={e=>{e.preventDefault();if(dragIdx!==null&&dragIdx!==idx){reorderItems(dragIdx,idx);}setDragIdx(null);}} style={{display:'flex', alignItems:'center', gap:10, background:THEME.cardBg, borderRadius:12, padding:'0.75rem 1rem', border:'1px solid rgba(128,128,128,0.14)', opacity:dragIdx===idx?0.4:item.done?0.5:1, transition:'opacity 0.2s'}}>
              <span style={{cursor:'grab', color:THEME.subtext, fontSize:'0.85rem', flexShrink:0, userSelect:'none'}}>⠿</span>
              <div onClick={()=>toggle(item.id)} style={{width:22, height:22, borderRadius:'50%', border:item.done?'none':'1.5px solid rgba(128,128,128,0.35)', background:item.done?COLOR[item.color]?.main||'#D4695A':'none', flexShrink:0, display:'flex', alignItems:'center', justifyContent:'center', fontSize:11, color:'white', transition:'all 0.2s', cursor:'pointer'}}>{item.done?'✓':''}</div>
              {editingId===item.id ? (
                <input autoFocus value={editText} onChange={e=>setEditText(e.target.value)} onKeyDown={e=>{if(e.key==='Enter'){if(editText.trim())editItem(item.id,editText.trim());setEditingId(null);}if(e.key==='Escape')setEditingId(null);}} onBlur={()=>{if(editText.trim())editItem(item.id,editText.trim());setEditingId(null);}} style={{flex:1, fontSize:'0.85rem', fontFamily:'Outfit,sans-serif', border:'none', borderBottom:'1.5px solid rgba(128,128,128,0.3)', background:'none', color:THEME.text, outline:'none', padding:'2px 0'}}/>
              ) : (
                <span onClick={e=>{e.stopPropagation();if(!item.done){setEditText(item.text);setEditingId(item.id);}}} style={{flex:1, fontSize:'0.85rem', color:THEME.text, textDecoration:item.done?'line-through':'none', cursor:item.done?'default':'text'}}>{item.text}</span>
              )}
              <button onClick={()=>removeItem(item.id)} style={{background:'none', border:'none', cursor:'pointer', fontSize:'1rem', color:THEME.subtext, padding:'0 2px', flexShrink:0, lineHeight:1}}>×</button>
            </div>
          ))}
        </div>
        {removedItem && (
          <div style={{display:'flex', alignItems:'center', justifyContent:'space-between', background:THEME.cardBg, borderRadius:10, padding:'0.6rem 1rem', marginBottom:'0.75rem', border:'1px solid rgba(128,128,128,0.15)', fontSize:'0.8rem', color:THEME.subtext}}>
            <span>Removed "{removedItem.text.slice(0,30)}{removedItem.text.length>30?'...':''}"</span>
            <button onClick={undoRemove} style={{background:'none', border:'none', color:COLOR.coral?.main||'#D4695A', fontFamily:'Outfit,sans-serif', fontSize:'0.8rem', fontWeight:600, cursor:'pointer'}}>Undo</button>
          </div>
        )}

        <div style={{display:'flex', gap:8, marginBottom:'0.75rem'}}>
          <input value={newItem} onChange={e=>setNewItem(e.target.value)} onKeyDown={e=>e.key==='Enter'&&addItem()} placeholder="Add something to your morning..." style={{flex:1, border:'none', borderBottom:'1px solid rgba(128,128,128,0.3)', background:'none', fontFamily:'Outfit,sans-serif', fontSize:'0.83rem', padding:'6px 2px', color:THEME.text, outline:'none'}}/>
          <button onClick={addItem} style={{background:'none', border:'none', cursor:'pointer', fontSize:'1.1rem', opacity:0.5, color:THEME.text}}>+</button>
        </div>

        {items.length > 0 && done > 0 && (
          <button onClick={resetChecklist} style={{background:'none', border:'1px solid rgba(128,128,128,0.25)', borderRadius:50, padding:'0.4rem 1rem', fontFamily:'Outfit,sans-serif', fontSize:'0.72rem', fontWeight:500, color:THEME.subtext, cursor:'pointer', marginBottom:'0.75rem', display:'flex', alignItems:'center', gap:6}}>↺ Reset checklist</button>
        )}

        {pct===100 && (
          <div style={{background:'#E4F0EE', borderRadius:14, padding:'1rem 1.25rem', textAlign:'center', marginBottom:'1rem', border:'1px solid rgba(91,158,143,0.2)'}}>
            <div style={{fontFamily:"'Cormorant Garamond',serif", fontSize:'1.3rem', fontWeight:600, color:'#2D6B60', marginBottom:2}}>Morning complete.</div>
            <div style={{fontSize:'0.78rem', color:'#2D6B60', fontStyle:'italic'}}>You handled every single thing. Go get 'em.</div>
          </div>
        )}

      </div>
    </div>
  );
}

function EveningCommandCenter({ onDismiss, userId, profile, onProfileChange }) {
  const [items, setItems] = useState(() => {
    try { const s = localStorage.getItem('eveningItems'); if (s) return JSON.parse(s); } catch(e) {}
    if (profile?.evening_items?.length) return profile.evening_items.map(i => ({...i, done:false}));
    return [];
  });
  const [newItem, setNewItem] = useState('');
  const done = items.filter(i => i.done).length;
  const pct = items.length === 0 ? 0 : Math.round((done / items.length) * 100);
  const toggle = (id) => setItems(prev => {
    const next = prev.map(i => i.id === id ? {...i, done:!i.done} : i);
    localStorage.setItem('eveningItems', JSON.stringify(next));
    return next;
  });
  const saveProfile = useCallback(async (eveningItems) => {
    localStorage.setItem('eveningItems', JSON.stringify(eveningItems));
    const toSave = eveningItems.map(({done, ...rest}) => rest);
    if (!userId) return;
    const updates = { user_id: userId, evening_items: toSave };
    await supabase.from('profile').upsert(updates, { onConflict: 'user_id' });
    if (onProfileChange) onProfileChange({ ...profile, evening_items: toSave });
  }, [userId, profile, onProfileChange]);
  const addItem = () => {
    if (!newItem.trim()) return;
    const updated = [...items, { id:Date.now(), text:newItem.trim(), tag:'self', color:'plum', done:false }];
    setItems(updated);
    setNewItem('');
    saveProfile(updated);
  };
  const [removedItem, setRemovedItem] = useState(null);
  const [undoTimer, setUndoTimer] = useState(null);
  const removeItem = (id) => {
    const item = items.find(i => i.id === id);
    const updated = items.filter(i => i.id !== id);
    setItems(updated);
    saveProfile(updated);
    if (item) {
      setRemovedItem(item);
      if (undoTimer) clearTimeout(undoTimer);
      setUndoTimer(setTimeout(() => setRemovedItem(null), 4000));
    }
  };
  const undoRemove = () => {
    if (removedItem) {
      const restored = [...items, removedItem];
      setItems(restored);
      saveProfile(restored);
      setRemovedItem(null);
      if (undoTimer) clearTimeout(undoTimer);
    }
  };
  const editItem = (id, newText) => {
    const updated = items.map(i => i.id === id ? {...i, text: newText} : i);
    setItems(updated);
    saveProfile(updated);
  };
  const resetChecklist = () => {
    const reset = items.map(i => ({...i, done: false}));
    setItems(reset);
    localStorage.setItem('eveningItems', JSON.stringify(reset));
  };
  const [editingId, setEditingId] = useState(null);
  const [editText, setEditText] = useState('');
  const [dragIdx, setDragIdx] = useState(null);
  const reorderItems = (from, to) => {
    const arr = [...items];
    const [moved] = arr.splice(from, 1);
    arr.splice(to, 0, moved);
    setItems(arr);
    localStorage.setItem('eveningItems', JSON.stringify(arr));
  };

  return (
    <div style={{background:'#FAF7F2', minHeight:'100vh', paddingTop:'1rem'}}>
      <div style={{padding:'0 1.5rem 1rem', display:'flex', justifyContent:'space-between', alignItems:'center'}}>
        <div onClick={onDismiss} style={{fontFamily:"'Cormorant Garamond',serif", fontSize:'1.4rem', fontWeight:600, letterSpacing:'0.04em', cursor:'pointer', transition:'opacity 0.2s'}} onMouseEnter={e=>e.target.style.opacity='0.7'} onMouseLeave={e=>e.target.style.opacity='1'}>Cleared<span style={{color:'#D4695A'}}>.</span></div>
        <button onClick={onDismiss} style={{background:'#8B7BA8', color:'white', border:'none', borderRadius:50, padding:'0.4rem 1rem', fontFamily:'Outfit,sans-serif', fontSize:'0.72rem', fontWeight:500, cursor:'pointer'}}>Back to my day</button>
      </div>
      <div style={{padding:'0 1.5rem', maxWidth:480, margin:'0 auto'}}>
        <div style={{fontFamily:"'Cormorant Garamond',serif", fontSize:'2rem', fontWeight:600, color:THEME.text, lineHeight:1.1, marginBottom:'1.5rem'}}>Let's wind<br/>your day down.</div>

        <div style={{fontSize:'0.6rem', fontWeight:600, letterSpacing:'0.14em', textTransform:'uppercase', color:THEME.subtext, marginBottom:'0.75rem'}}>Your evening checklist</div>

        {items.length > 0 && (
          <div style={{marginBottom:'1.25rem'}}>
            <div style={{height:6, background:'rgba(128,128,128,0.15)', borderRadius:50, overflow:'hidden', marginBottom:5}}>
              <div style={{height:'100%', width:`${pct}%`, background:pct===100?'#5B9E8F':'#8B7BA8', borderRadius:50, transition:'width 0.4s ease'}}/>
            </div>
            <div style={{display:'flex', justifyContent:'space-between', fontSize:'0.68rem', color:THEME.subtext}}>
              <span>{done} of {items.length} done</span><span>{pct}%</span>
            </div>
          </div>
        )}

        <div style={{display:'flex', flexDirection:'column', gap:8, marginBottom:'1.25rem'}}>
          {items.map((item,idx) => (
            <div key={item.id} draggable={editingId!==item.id} onDragStart={()=>setDragIdx(idx)} onDragEnd={()=>setDragIdx(null)} onDragOver={e=>e.preventDefault()} onDrop={e=>{e.preventDefault();if(dragIdx!==null&&dragIdx!==idx){reorderItems(dragIdx,idx);}setDragIdx(null);}} style={{display:'flex', alignItems:'center', gap:10, background:THEME.cardBg, borderRadius:12, padding:'0.75rem 1rem', border:'1px solid rgba(128,128,128,0.14)', opacity:dragIdx===idx?0.4:item.done?0.5:1, transition:'opacity 0.2s'}}>
              <span style={{cursor:'grab', color:THEME.subtext, fontSize:'0.85rem', flexShrink:0, userSelect:'none'}}>⠿</span>
              <div onClick={()=>toggle(item.id)} style={{width:22, height:22, borderRadius:'50%', border:item.done?'none':'1.5px solid rgba(128,128,128,0.35)', background:item.done?COLOR[item.color]?.main||'#8B7BA8':'none', flexShrink:0, display:'flex', alignItems:'center', justifyContent:'center', fontSize:11, color:'white', transition:'all 0.2s', cursor:'pointer'}}>{item.done?'✓':''}</div>
              {editingId===item.id ? (
                <input autoFocus value={editText} onChange={e=>setEditText(e.target.value)} onKeyDown={e=>{if(e.key==='Enter'){if(editText.trim())editItem(item.id,editText.trim());setEditingId(null);}if(e.key==='Escape')setEditingId(null);}} onBlur={()=>{if(editText.trim())editItem(item.id,editText.trim());setEditingId(null);}} style={{flex:1, fontSize:'0.85rem', fontFamily:'Outfit,sans-serif', border:'none', borderBottom:'1.5px solid rgba(128,128,128,0.3)', background:'none', color:THEME.text, outline:'none', padding:'2px 0'}}/>
              ) : (
                <span onClick={e=>{e.stopPropagation();if(!item.done){setEditText(item.text);setEditingId(item.id);}}} style={{flex:1, fontSize:'0.85rem', color:THEME.text, textDecoration:item.done?'line-through':'none', cursor:item.done?'default':'text'}}>{item.text}</span>
              )}
              <button onClick={()=>removeItem(item.id)} style={{background:'none', border:'none', cursor:'pointer', fontSize:'1rem', color:THEME.subtext, padding:'0 2px', flexShrink:0, lineHeight:1}}>×</button>
            </div>
          ))}
        </div>
        {removedItem && (
          <div style={{display:'flex', alignItems:'center', justifyContent:'space-between', background:THEME.cardBg, borderRadius:10, padding:'0.6rem 1rem', marginBottom:'0.75rem', border:'1px solid rgba(128,128,128,0.15)', fontSize:'0.8rem', color:THEME.subtext}}>
            <span>Removed "{removedItem.text.slice(0,30)}{removedItem.text.length>30?'...':''}"</span>
            <button onClick={undoRemove} style={{background:'none', border:'none', color:COLOR.coral?.main||'#D4695A', fontFamily:'Outfit,sans-serif', fontSize:'0.8rem', fontWeight:600, cursor:'pointer'}}>Undo</button>
          </div>
        )}

        <div style={{display:'flex', gap:8, marginBottom:'0.75rem'}}>
          <input value={newItem} onChange={e=>setNewItem(e.target.value)} onKeyDown={e=>e.key==='Enter'&&addItem()} placeholder="Add something to your evening..." style={{flex:1, border:'none', borderBottom:'1px solid rgba(128,128,128,0.3)', background:'none', fontFamily:'Outfit,sans-serif', fontSize:'0.83rem', padding:'6px 2px', color:THEME.text, outline:'none'}}/>
          <button onClick={addItem} style={{background:'none', border:'none', cursor:'pointer', fontSize:'1.1rem', opacity:0.5, color:THEME.text}}>+</button>
        </div>

        {items.length > 0 && done > 0 && (
          <button onClick={resetChecklist} style={{background:'none', border:'1px solid rgba(128,128,128,0.25)', borderRadius:50, padding:'0.4rem 1rem', fontFamily:'Outfit,sans-serif', fontSize:'0.72rem', fontWeight:500, color:THEME.subtext, cursor:'pointer', marginBottom:'0.75rem', display:'flex', alignItems:'center', gap:6}}>↺ Reset checklist</button>
        )}

        {pct===100 && (
          <div style={{background:'#EDE9F5', borderRadius:14, padding:'1rem 1.25rem', textAlign:'center', marginBottom:'1rem', border:'1px solid rgba(139,123,168,0.2)'}}>
            <div style={{fontFamily:"'Cormorant Garamond',serif", fontSize:'1.3rem', fontWeight:600, color:'#4A3A6B', marginBottom:2}}>Evening complete.</div>
            <div style={{fontSize:'0.78rem', color:'#4A3A6B', fontStyle:'italic'}}>Tomorrow-you is going to be so grateful. Rest well.</div>
          </div>
        )}

      </div>
    </div>
  );
}

function Confetti({ active }) {
  const colors = ['#D4695A','#5B9E8F','#C4985A','#8B7BA8','#D4838F','#7BA88B'];
  if (!active) return null;
  return (
    <div style={{position:'fixed', top:0, left:0, width:'100vw', height:'100vh', pointerEvents:'none', zIndex:998}}>
      {Array.from({length:28}).map((_,i) => {
        const size=6+Math.random()*8, left=10+Math.random()*80, dur=1.4+Math.random()*0.8, delay=Math.random()*0.5;
        return <div key={i} style={{position:'absolute', top:70, left:`${left}vw`, width:size, height:size, borderRadius:'50%', background:randomFrom(colors), animation:`fall ${dur}s ${delay}s linear forwards`}}/>;
      })}
    </div>
  );
}

function Toast({ show, msg, sub }) {
  return (
    <div style={{position:'fixed', top:80, left:'50%', transform:show?'translateX(-50%) translateY(0)':'translateX(-50%) translateY(-20px)', opacity:show?1:0, background:THEME.cardBg, borderRadius:20, border:'1.5px solid rgba(212,105,90,0.25)', padding:'1.1rem 2rem', zIndex:999, textAlign:'center', minWidth:260, maxWidth:340, pointerEvents:'none', transition:'opacity 0.35s ease, transform 0.35s ease'}}>
      <div style={{width:38, height:38, borderRadius:'50%', background:'#F5E8E6', border:'2px solid #D4695A', display:'flex', alignItems:'center', justifyContent:'center', margin:'0 auto 0.6rem', fontSize:14, color:'#8B3A2E', fontWeight:600}}>✓</div>
      <div style={{fontFamily:"'Cormorant Garamond',serif", fontSize:'1.25rem', fontWeight:600, color:THEME.text, marginBottom:2}}>{msg}</div>
      <div style={{fontSize:'0.75rem', color:THEME.subtext, fontStyle:'italic', fontWeight:300}}>{sub}</div>
    </div>
  );
}

function TaskItem({ task, quadrant, index, txtColor, onToggle, onDelete, onEdit, onDragStart, onDragOver, onDrop, dragging }) {
  const c = COLOR[quadrant];
  const tc = txtColor || getReadableTextColor(c.bg);
  const dim = tc === '#F5F5F5' ? 'B3' : '99';
  const [editing, setEditing] = useState(false);
  const [editText, setEditText] = useState(task.text);
  const handleSave = () => { if (editText.trim() && editText.trim() !== task.text) onEdit(editText.trim()); setEditing(false); };
  return (
    <div
      draggable={!editing}
      onDragStart={e=>onDragStart(e,index)}
      onDragOver={e=>{e.preventDefault(); onDragOver(index);}}
      onDrop={e=>{e.preventDefault(); onDrop(index);}}
      onDragEnd={()=>onDrop(null)}
      style={{display:'flex', alignItems:'flex-start', gap:6, marginBottom:8, opacity:dragging?0.4:1, transition:'opacity 0.15s'}}
    >
      <span style={{cursor:'grab', color:`${tc}${dim}`, fontSize:'0.9rem', flexShrink:0, marginTop:2, lineHeight:1, userSelect:'none'}}>⠿</span>
      <button onClick={onToggle} style={{width:18, height:18, borderRadius:'50%', border:`1.5px solid ${tc}${dim}`, cursor:'pointer', flexShrink:0, marginTop:2, display:'flex', alignItems:'center', justifyContent:'center', background:task.done?tc:'none', color:task.done?(tc==='#F5F5F5'?'#2D2D2D':'#F5F5F5'):tc, fontSize:10, fontFamily:'Outfit,sans-serif'}}>{task.done?'✓':''}</button>
      {editing ? (
        <input autoFocus value={editText} onChange={e=>setEditText(e.target.value)} onKeyDown={e=>{if(e.key==='Enter')handleSave();if(e.key==='Escape'){setEditText(task.text);setEditing(false);}}} onBlur={handleSave} style={{flex:1, fontSize:'0.83rem', fontFamily:'Outfit,sans-serif', border:'none', borderBottom:`1.5px solid ${tc}${dim}`, background:'none', color:tc, outline:'none', padding:'2px 0'}}/>
      ) : (
        <span onClick={e=>{e.stopPropagation();if(!task.done){setEditText(task.text);setEditing(true);}}} style={{fontSize:'0.83rem', lineHeight:1.4, color:task.done?`${tc}${dim}`:tc, cursor:task.done?'default':'text', flex:1, textDecoration:task.done?'line-through':'none'}}>{task.text}</span>
      )}
      <button onClick={onDelete} style={{background:'none', border:'none', cursor:'pointer', fontSize:'1rem', color:`${tc}${dim}`, padding:'0 2px', flexShrink:0, lineHeight:1}}>×</button>
    </div>
  );
}

function GroceryList({ items, setItems, txtColor }) {
  const [expanded, setExpanded] = useState(false);
  const [input, setInput] = useState('');
  const add = () => { if (!input.trim()) return; setItems([...items, { id:Date.now(), text:input.trim(), done:false }]); setInput(''); };
  const toggle = (id) => setItems(items.map(i => i.id === id ? {...i, done:!i.done} : i).sort((a,b)=> a.done===b.done?0:a.done?1:-1));
  const remove = (id) => setItems(items.filter(i => i.id !== id));
  const tc = txtColor || '#2D2D2D';
  const dim = tc === '#F5F5F5' ? 'B3' : '99';
  return (
    <div style={{marginTop:12, borderTop:`1px dashed ${tc}40`, paddingTop:12}}>
      <button onClick={()=>setExpanded(!expanded)} style={{background:'none', border:'none', cursor:'pointer', fontFamily:'Outfit,sans-serif', fontSize:'0.75rem', fontWeight:600, color:tc, letterSpacing:'0.08em', textTransform:'uppercase', display:'flex', alignItems:'center', gap:6, padding:0, width:'100%', justifyContent:'space-between'}}>
        <span>🛒 Grocery List {items.length > 0 && `(${items.filter(i=>!i.done).length})`}</span>
        <span style={{fontSize:'0.9rem'}}>{expanded?'−':'+'}</span>
      </button>
      {expanded && (
        <div style={{marginTop:10}}>
          {items.map(item => (
            <div key={item.id} style={{display:'flex', alignItems:'center', gap:8, marginBottom:6}}>
              <button onClick={()=>toggle(item.id)} style={{width:16, height:16, borderRadius:'50%', border:`1.5px solid ${tc}${dim}`, cursor:'pointer', flexShrink:0, background:item.done?tc:'none', color:item.done?(tc==='#F5F5F5'?'#2D2D2D':'#F5F5F5'):'white', fontSize:9, display:'flex', alignItems:'center', justifyContent:'center'}}>{item.done?'✓':''}</button>
              <span onClick={()=>toggle(item.id)} style={{flex:1, fontSize:'0.8rem', color:item.done?`${tc}${dim}`:tc, cursor:'pointer', textDecoration:item.done?'line-through':'none'}}>{item.text}</span>
              <button onClick={()=>remove(item.id)} style={{background:'none', border:'none', cursor:'pointer', fontSize:'0.95rem', color:`${tc}${dim}`, padding:'0 2px', lineHeight:1}}>×</button>
            </div>
          ))}
          <div style={{display:'flex', gap:8, marginTop:6}}>
            <input value={input} onChange={e=>setInput(e.target.value)} onKeyDown={e=>e.key==='Enter'&&add()} placeholder="Add a grocery item..." style={{flex:1, border:'none', borderBottom:`1px solid ${tc}66`, background:'none', fontFamily:'Outfit,sans-serif', fontSize:'0.78rem', padding:'4px 2px', color:tc, outline:'none'}}/>
            <button onClick={add} style={{background:'none', border:'none', cursor:'pointer', fontSize:'1rem', color:`${tc}${dim}`, padding:'0 4px'}}>+</button>
          </div>
        </div>
      )}
    </div>
  );
}

function ThemePicker({ theme, setTheme, compact }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  useEffect(() => {
    const close = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', close);
    return () => document.removeEventListener('mousedown', close);
  }, []);
  const current = THEMES[theme] || THEMES.deepsea;
  const sz = compact ? {font:'0.62rem',pad:'0.3rem 0.7rem'} : {font:'0.72rem',pad:'0.4rem 0.9rem'};
  return (
    <div ref={ref} style={{position:'relative', display:'inline-block'}}>
      <button onClick={()=>setOpen(!open)} aria-haspopup="listbox" aria-expanded={open} style={{background:THEME.cardBg, color:THEME.text, border:'1px solid rgba(128,128,128,0.25)', borderRadius:50, padding:sz.pad, fontFamily:'Inter,Outfit,sans-serif', fontSize:sz.font, fontWeight:500, cursor:'pointer', display:'flex', alignItems:'center', gap:6, outline:'none'}}>
        <span style={{width:10, height:10, borderRadius:3, background:COLOR.coral?.bg||'#ccc', flexShrink:0, border:'1px solid rgba(128,128,128,0.15)'}}/>
        {current.label}
        <span style={{fontSize:'0.6rem', transition:'transform 0.2s', transform:open?'rotate(180deg)':'none'}}>&#9662;</span>
      </button>
      {open && (
        <div role="listbox" aria-label="Choose theme" style={{position:'absolute', top:'calc(100% + 6px)', left:0, background:THEME.cardBg, border:'1px solid rgba(128,128,128,0.15)', borderRadius:14, padding:'6px 0', minWidth:190, boxShadow:'0 8px 24px rgba(0,0,0,0.1)', zIndex:200}}>
          {Object.entries(THEMES).map(([k,t])=>{
            const active = k === theme;
            return (
              <button key={k} role="option" aria-selected={active} onClick={()=>{setTheme(k);setOpen(false);}} style={{display:'flex', alignItems:'center', gap:8, width:'100%', padding:'8px 14px', background:active?'rgba(128,128,128,0.08)':'none', border:'none', cursor:'pointer', fontFamily:'Inter,Outfit,sans-serif', fontSize:'0.78rem', fontWeight:active?600:400, color:THEME.text, textAlign:'left', outline:'none'}}>
                <span style={{width:12, height:12, borderRadius:3, background:t.colors.coral.bg, flexShrink:0, border:'1px solid rgba(128,128,128,0.1)'}}/>
                {t.label}
                {active && <span style={{marginLeft:'auto', fontSize:'0.65rem', color:THEME.subtext}}>&#10003;</span>}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}

function Quadrant({ q, tasks, onToggle, onAdd, onDelete, onEdit, onReorder, grocery, setGrocery }) {
  const [input, setInput] = useState('');
  const [dragIdx, setDragIdx] = useState(null);
  const c = COLOR[q.color];
  const submit = () => { if (input.trim()) { onAdd(q.key, input.trim()); setInput(''); }};
  const handleDragStart = (e, i) => { setDragIdx(i); e.dataTransfer.effectAllowed = 'move'; };
  const handleDragOver = (i) => {};
  const handleDrop = (targetIdx) => {
    if (targetIdx === null || dragIdx === null || dragIdx === targetIdx) { setDragIdx(null); return; }
    onReorder(q.key, dragIdx, targetIdx);
    setDragIdx(null);
  };
  return (
    <div style={{background:c.bg, border:`1.5px solid ${c.border}`, borderRadius:16, padding:'1.25rem', minHeight:200}}>
      {(() => { const txtColor = getReadableTextColor(c.bg); const isDark = txtColor === '#F5F5F5'; const dimSuffix = isDark ? 'B3' : '99'; const placeholderOpacity = isDark ? 'BF' : 'A6'; const qId = `q-${q.key}`; return (<>
      <style>{`.${qId} input::placeholder,.${qId} textarea::placeholder{color:${txtColor}${placeholderOpacity} !important;opacity:1;}`}</style>
      <div className={qId}>
      <div style={{fontSize:'0.6rem', fontWeight:600, letterSpacing:'0.14em', textTransform:'uppercase', color:`${txtColor}${dimSuffix}`, marginBottom:4}}>{q.sub}</div>
      <div style={{fontFamily:"'Cormorant Garamond',serif", fontSize:'1.15rem', fontWeight:600, color:txtColor, marginBottom:'0.9rem'}}>{q.label}</div>
      <div onDragOver={e=>e.preventDefault()} onDrop={e=>{e.preventDefault();handleDrop(0);}} style={{height:dragIdx!==null&&dragIdx!==0?6:0, transition:'height 0.15s'}}/>
      {tasks.map((task,i) => <TaskItem key={task.id} task={task} quadrant={q.color} index={i} txtColor={txtColor} onToggle={()=>onToggle(q.key,i)} onDelete={()=>onDelete(q.key,i)} onEdit={(text)=>onEdit(q.key,i,text)} onDragStart={handleDragStart} onDragOver={handleDragOver} onDrop={handleDrop} dragging={dragIdx===i}/>)}
      <div style={{display:'flex', gap:8, marginTop:10}}>
        <input value={input} onChange={e=>setInput(e.target.value)} onKeyDown={e=>e.key==='Enter'&&submit()} placeholder="Add a task..." style={{flex:1, border:'none', borderBottom:`1px solid ${txtColor}66`, background:'none', fontFamily:'Outfit,sans-serif', fontSize:'0.8rem', padding:'4px 2px', color:txtColor, outline:'none'}}/>
        <button onClick={submit} style={{background:'none', border:'none', cursor:'pointer', fontSize:'1rem', padding:'0 4px', color:`${txtColor}${dimSuffix}`}}>+</button>
      </div>
      {q.hasGrocery && <GroceryList items={grocery} setItems={setGrocery} txtColor={txtColor}/>}
      </div>
      </>); })()}
    </div>
  );
}

function HabitTracker({ showToast, userId, initialHabits, isPremium, onUpgrade }) {
  const [habits, setHabits] = useState(() => {
    if (initialHabits?.length) return initialHabits;
    try { const s = localStorage.getItem('clearedGuestHabits'); if (s) return JSON.parse(s); } catch(e) {}
    return [];
  });
  const [newHabit, setNewHabit] = useState('');
  const saveGuestHabits = (list) => { if (!userId) localStorage.setItem('clearedGuestHabits', JSON.stringify(list)); };
  const saveHabit = async (habit) => {
    if (!userId) return;
    await supabase.from('habits').upsert({ id: habit.id, user_id: userId, name: habit.name, streak: habit.streak, checked: habit.checked, color: habit.color }, { onConflict: 'id' });
  };
  const check = (id) => {
    setHabits(prev => {
      const next = prev.map(h => {
        if (h.id !== id) return h;
        showToast();
        const updated = {...h, checked:true, streak:h.streak+1};
        saveHabit(updated);
        return updated;
      });
      saveGuestHabits(next);
      return next;
    });
  };
  const adjustStreak = (id, delta) => {
    setHabits(prev => {
      const next = prev.map(h => {
        if (h.id !== id) return h;
        const updated = {...h, streak: Math.max(0, h.streak + delta)};
        saveHabit(updated);
        return updated;
      });
      saveGuestHabits(next);
      return next;
    });
  };
  const [habitDragIdx, setHabitDragIdx] = useState(null);
  const reorderHabits = (from, to) => {
    const arr = [...habits];
    const [moved] = arr.splice(from, 1);
    arr.splice(to, 0, moved);
    setHabits(arr);
    saveGuestHabits(arr);
  };
  const addHabit = async () => {
    if (!newHabit.trim()) return;
    if (!isPremium && habits.length >= 3) { onUpgrade && onUpgrade(); return; }
    const habit = { id:Date.now(), name:newHabit.trim(), streak:0, checked:false, color:HABIT_COLORS[habits.length%HABIT_COLORS.length], weekCount:0, monthCount:0 };
    const next = [...habits, habit];
    setHabits(next);
    setNewHabit('');
    saveGuestHabits(next);
    if (userId) {
      await supabase.from('habits').insert({ id: habit.id, user_id: userId, name: habit.name, streak: habit.streak, checked: habit.checked, color: habit.color });
    }
  };
  return (
    <div>
      <div style={{fontFamily:"'Cormorant Garamond',serif", fontSize:'1.6rem', fontWeight:300, marginBottom:'0.25rem'}}>Your Habits</div>
      <div style={{fontSize:'0.78rem', color:THEME.subtext, marginBottom:'1.5rem', fontWeight:300}}>Show up every day. That's it.</div>
      <div style={{display:'flex', flexDirection:'column', gap:12}}>
        {habits.map((h,idx) => {
          const goalTier = h.streak < 30 ? {target:30,label:'30-day goal'} : h.streak < 90 ? {target:90,label:'Quarterly goal'} : h.streak < 365 ? {target:365,label:'Yearly goal'} : {target:h.streak,label:'Legendary streak'};
          const pct = goalTier.target > 0 ? Math.min(100, Math.round((h.streak/goalTier.target)*100)) : 100;
          const weekCount = h.weekCount || Math.min(h.streak, 7);
          const monthCount = h.monthCount || Math.min(h.streak, 30);
          return (
            <div key={h.id} draggable onDragStart={()=>setHabitDragIdx(idx)} onDragEnd={()=>setHabitDragIdx(null)} onDragOver={e=>e.preventDefault()} onDrop={e=>{e.preventDefault();if(habitDragIdx!==null&&habitDragIdx!==idx){reorderHabits(habitDragIdx,idx);}setHabitDragIdx(null);}} style={{background:THEME.cardBg, borderRadius:16, padding:'1.1rem 1.25rem', border:'1px solid rgba(128,128,128,0.15)', display:'flex', alignItems:'center', gap:12, opacity:habitDragIdx===idx?0.4:1, transition:'opacity 0.15s'}}>
              <span style={{cursor:'grab', color:THEME.subtext, fontSize:'1rem', flexShrink:0, userSelect:'none'}}>⠿</span>
              <div style={{display:'flex', flexDirection:'column', alignItems:'center', minWidth:40}}>
                <div style={{fontFamily:"'Cormorant Garamond',serif", fontSize:'1.6rem', fontWeight:600, color:h.color, lineHeight:1}}>{h.streak}</div>
                <div style={{fontSize:'0.5rem', color:THEME.subtext, textTransform:'uppercase', letterSpacing:'0.08em'}}>streak</div>
              </div>
              <div style={{flex:1}}>
                <div style={{fontSize:'0.88rem', fontWeight:500, color:THEME.text, marginBottom:4}}>{h.name}</div>
                <div style={{display:'flex', gap:10, marginBottom:5}}>
                  <span style={{fontSize:'0.6rem', color:THEME.subtext}}>{weekCount}/7 this week</span>
                  <span style={{fontSize:'0.6rem', color:THEME.subtext}}>{monthCount}/30 this month</span>
                </div>
                <div style={{height:5, background:'rgba(128,128,128,0.15)', borderRadius:50, overflow:'hidden'}}>
                  <div style={{height:'100%', width:`${pct}%`, background:h.color, borderRadius:50, transition:'width 0.4s ease'}}/>
                </div>
                <div style={{fontSize:'0.6rem', color:THEME.subtext, marginTop:3}}>
                  {pct===100&&goalTier.label==='Legendary streak' ? '🏆 Legendary!' : pct===100 ? `🎉 ${goalTier.label} complete!` : `${pct}% to ${goalTier.label}`}
                </div>
              </div>
              <button onClick={()=>adjustStreak(h.id,-1)} style={{width:36, height:36, borderRadius:'50%', border:`1.5px solid rgba(128,128,128,0.3)`, background:'none', cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center', fontSize:16, color:THEME.subtext, flexShrink:0, fontWeight:500}}>−</button>
              <button onClick={()=>check(h.id)} style={{width:46, height:46, borderRadius:'50%', border:`2px solid ${h.checked?h.color:'rgba(128,128,128,0.35)'}`, background:h.checked?h.color:'none', cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center', fontSize:h.checked?20:22, color:h.checked?'white':THEME.subtext, flexShrink:0, transition:'all 0.2s', fontWeight:h.checked?700:300}}>{h.checked?'✓':'+'}</button>
              <button onClick={()=>{const next=habits.filter(x=>x.id!==h.id);setHabits(next);saveGuestHabits(next);if(userId) supabase.from('habits').delete().eq('id',h.id).then(()=>{});}} style={{background:'none', border:'none', cursor:'pointer', fontSize:'1rem', color:'rgba(128,128,128,0.35)', padding:'0 2px'}}>×</button>
            </div>
          );
        })}
      </div>
      {!isPremium && habits.length >= 3 ? (
        <div style={{marginTop:'1.25rem', background:COLOR.gold?.bg||'#F5EDDF', borderRadius:12, padding:'0.75rem 1rem', border:`1px solid ${COLOR.gold?.border||'rgba(196,152,90,0.2)'}`, display:'flex', alignItems:'center', justifyContent:'space-between', gap:8}}>
          <span style={{fontSize:'0.78rem', color:COLOR.gold?.dark||THEME.text}}>3 habit limit reached</span>
          <button onClick={()=>onUpgrade&&onUpgrade()} style={{background:COLOR.gold?.main||'#C4982A', color:'white', border:'none', borderRadius:50, padding:'0.35rem 0.9rem', fontFamily:'Outfit,sans-serif', fontSize:'0.72rem', fontWeight:600, cursor:'pointer', flexShrink:0}}>Upgrade</button>
        </div>
      ) : (
        <div style={{display:'flex', gap:8, marginTop:'1.25rem'}}>
          <input value={newHabit} onChange={e=>setNewHabit(e.target.value)} onKeyDown={e=>e.key==='Enter'&&addHabit()} placeholder="Add a new habit..." style={{flex:1, border:'none', borderBottom:'1px solid rgba(128,128,128,0.3)', background:'none', fontFamily:'Outfit,sans-serif', fontSize:'0.88rem', padding:'6px 2px', color:THEME.text, outline:'none'}}/>
          <button onClick={addHabit} style={{background:'#D4695A', color:'white', border:'none', borderRadius:50, padding:'0.5rem 1.2rem', fontFamily:'Outfit,sans-serif', fontSize:'0.8rem', fontWeight:500, cursor:'pointer'}}>+ Add</button>
        </div>
      )}
    </div>
  );
}

export function AuthScreen({ onAuth }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [isSignUp, setIsSignUp] = useState(false);
  const [error, setError] = useState('');
  const [msg, setMsg] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log('Auth submit:', isSignUp ? 'SIGN UP' : 'SIGN IN', 'email:', email);
    setError(''); setMsg(''); setSubmitting(true);
    try {
      if (isSignUp) {
        console.log('Calling supabase.auth.signUp...');
        const { data, error: err } = await supabase.auth.signUp({ email, password });
        console.log('signUp response:', { data, error: err });
        if (err) { setError(err.message); }
        else if (data?.user?.identities?.length === 0) { setError('An account with this email already exists.'); }
        else if (data?.session) { console.log('Auto-confirmed, session received'); }
        else { setMsg('Check your email to confirm your account, then sign in.'); }
      } else {
        console.log('Calling supabase.auth.signInWithPassword...');
        const { data, error: err } = await supabase.auth.signInWithPassword({ email, password });
        console.log('signIn response:', { data, error: err });
        if (err) { setError(err.message); }
        else if (data?.user) { console.log('Sign in success, calling onAuth'); onAuth(data.user); }
      }
    } catch (ex) { console.error('Auth exception:', ex); setError('Something went wrong. Please try again.'); }
    setSubmitting(false);
  };
  const btnColor = isSignUp ? '#9BA4E0' : '#9BA4E0';
  return (
    <div style={{display:'flex', alignItems:'center', justifyContent:'center', minHeight:'100vh', background:'#F8FAF6', fontFamily:'Inter,Outfit,sans-serif', padding:'1rem'}}>
      <div key={isSignUp?'signup':'signin'} style={{background:'#FFFFFF', borderRadius:20, padding:'48px 40px', maxWidth:520, width:'100%', border:'1px solid rgba(128,128,128,0.12)', animation:'fadeIn 0.3s ease'}}>
        <style>{`@keyframes fadeIn{from{opacity:0;transform:translateY(8px)}to{opacity:1;transform:translateY(0)}} @media(max-width:640px){.auth-card{max-width:100%!important;padding:32px 20px!important;margin:0 16px;}}`}</style>
        <div style={{textAlign:'center', marginBottom:16}}><ClearedLogomark size={40} /></div>
        <div style={{fontFamily:'Georgia,serif', fontSize:'1.25rem', fontWeight:500, textAlign:'center', marginBottom:'1.75rem', color:'#1A2B22', letterSpacing:'0.12em', textTransform:'uppercase'}}>CLEARED<span style={{color:'#9BA4E0'}}>.</span></div>
        <div style={{fontFamily:'Georgia,serif', fontSize:'1.9rem', fontWeight:500, textAlign:'center', color:'#1A2B22', lineHeight:1.2, marginBottom:4}}>{isSignUp ? 'Create your account' : 'Welcome back'}</div>
        <div style={{fontSize:'0.875rem', color:'#5F7068', textAlign:'center', marginBottom:'1.75rem', fontStyle:'italic'}}>{isSignUp ? 'Start organizing your chaos in 30 seconds' : "Let's pick up where you left off"}</div>
        <form onSubmit={handleSubmit}>
          <input type="email" value={email} onChange={e=>setEmail(e.target.value)} placeholder="Your email" required style={{width:'100%', padding:'0.75rem 1rem', border:'1px solid rgba(128,128,128,0.25)', borderRadius:10, fontFamily:'Inter,sans-serif', fontSize:'0.9rem', marginBottom:12, outline:'none', boxSizing:'border-box', background:'#FFFFFF'}}/>
          <div style={{position:'relative', marginBottom:16}}>
            <input type={showPassword ? 'text' : 'password'} value={password} onChange={e=>setPassword(e.target.value)} placeholder={isSignUp ? 'Create a password (min 6 characters)' : 'Your password'} required minLength={isSignUp?6:undefined} style={{width:'100%', padding:'0.75rem 1rem', paddingRight:'2.5rem', border:'1px solid rgba(128,128,128,0.25)', borderRadius:10, fontFamily:'Inter,sans-serif', fontSize:'0.9rem', outline:'none', boxSizing:'border-box', background:'#FFFFFF'}}/>
            <button type="button" onClick={()=>setShowPassword(!showPassword)} style={{position:'absolute', right:10, top:'50%', transform:'translateY(-50%)', background:'none', border:'none', cursor:'pointer', fontSize:'1rem', color:'#5F7068', padding:'4px 8px'}}>{showPassword ? '🙈' : '👁'}</button>
          </div>
          {error && <div style={{color:'#E8877E', fontSize:'0.82rem', marginBottom:12, textAlign:'center'}}>{error}</div>}
          {msg && <div style={{color:'#6DCCAE', fontSize:'0.82rem', marginBottom:12, textAlign:'center'}}>{msg}</div>}
          <button type="submit" disabled={submitting} style={{width:'100%', background:btnColor, color:'#26215C', border:'none', borderRadius:50, padding:'0.85rem', fontFamily:'Inter,sans-serif', fontSize:'0.92rem', fontWeight:600, cursor:submitting?'default':'pointer', opacity:submitting?0.7:1, letterSpacing:'0.02em', transition:'background 0.3s'}}>{submitting ? 'Please wait...' : (isSignUp ? 'Create my account' : 'Sign me in')}</button>
        </form>
        <div style={{textAlign:'center', marginTop:'1.5rem'}}>
          <span onClick={()=>{setIsSignUp(!isSignUp);setError('');setMsg('');}} style={{fontSize:'0.82rem', color:'#E8877E', cursor:'pointer', fontWeight:500, textDecoration:'none'}} onMouseEnter={e=>e.target.style.textDecoration='underline'} onMouseLeave={e=>e.target.style.textDecoration='none'}>{isSignUp ? 'Already have an account? Sign in' : "Don't have an account? Sign up"}</span>
        </div>
        {/* BETA: guest mode hidden during beta — restore after beta period ends
        <button onClick={()=>onAuth(null)} style={{width:'100%', background:'none', border:'1px solid rgba(128,128,128,0.25)', borderRadius:50, padding:'0.7rem', fontFamily:'Inter,sans-serif', fontSize:'0.78rem', fontWeight:500, color:'#5F7068', cursor:'pointer', marginTop:'0.85rem'}}>Continue without an account</button>
        */}
      </div>
    </div>
  );
}

function Onboarding({ onComplete }) {
  const [step, setStep] = useState(0);
  const [data, setData] = useState({ name:'', hasKids:false, numKids:'', works:'', wakeTime:'06:30', windDown:'21:00', biggestStruggle:'' });
  const update = (key,val) => setData(p=>({...p,[key]:val}));
  const inputStyle = {width:'100%', border:'none', borderBottom:'1.5px solid #D4695A', background:'none', fontFamily:'Outfit,sans-serif', fontSize:'16px', padding:'8px 0', color:THEME.text, outline:'none', boxSizing:'border-box'};
  const btnStyle = {background:'#D4695A', color:'white', border:'none', borderRadius:50, padding:'0.7rem 2rem', fontFamily:'Outfit,sans-serif', fontSize:'0.85rem', fontWeight:500, cursor:'pointer'};
  const skipStyle = {background:'none', border:'none', color:THEME.subtext, fontFamily:'Outfit,sans-serif', fontSize:'0.78rem', cursor:'pointer', textDecoration:'underline'};
  const steps = [
    { title:"First — what's your name?", sub:'just so we can make this feel like yours.', content:(
      <input value={data.name} onChange={e=>update('name',e.target.value)} placeholder="Your first name" style={inputStyle}/>
    )},
    { title:'Do you have kids at home?', sub:'no judgment either way — just helps us help you.', content:(
      <div style={{display:'flex', gap:12}}>
        <button onClick={()=>{update('hasKids',true);setStep(s=>s+1);}} style={{...btnStyle, background:data.hasKids?'#5B9E8F':THEME.cardBg, color:data.hasKids?'white':THEME.text, border:'1px solid rgba(128,128,128,0.3)', flex:1}}>Yes</button>
        <button onClick={()=>{update('hasKids',false);update('numKids','');setStep(s=>s+1);}} style={{...btnStyle, background:!data.hasKids?'#5B9E8F':THEME.cardBg, color:!data.hasKids?'white':THEME.text, border:'1px solid rgba(128,128,128,0.3)', flex:1}}>No</button>
      </div>
    )},
    ...(data.hasKids ? [{ title:'How many?', sub:'we love them already.', content:(
      <div style={{display:'flex', flexWrap:'wrap', gap:8}}>
        {['1','2','3','4','5+'].map(n=>(
          <button key={n} onClick={()=>update('numKids',n)} style={{...btnStyle, background:data.numKids===n?'#8B7BA8':THEME.cardBg, color:data.numKids===n?'white':THEME.text, border:'1px solid rgba(128,128,128,0.3)', padding:'0.5rem 1.2rem', flex:'none'}}>{n}</button>
        ))}
      </div>
    )}] : []),
    { title:'Do you work outside the home?', sub:'or remote, hybrid, freelance — however you hustle.', content:(
      <div style={{display:'flex', flexDirection:'column', gap:8}}>
        {['Full-time outside','Full-time remote','Part-time','Freelance / Self-employed','Stay at home','Student'].map(o=>(
          <button key={o} onClick={()=>update('works',o)} style={{...btnStyle, background:data.works===o?'#C4985A':THEME.cardBg, color:data.works===o?'white':THEME.text, border:'1px solid rgba(128,128,128,0.3)', padding:'0.55rem 1rem', textAlign:'left', borderRadius:12}}>{o}</button>
        ))}
      </div>
    )},
    { title:'When do you usually wake up?', sub:'no alarm shaming here.', content:(
      <input type="time" value={data.wakeTime} onChange={e=>update('wakeTime',e.target.value)} style={{...inputStyle, fontSize:'1.2rem', fontFamily:"'Cormorant Garamond',serif", fontWeight:600}}/>
    )},
    { title:'When do you start winding down?', sub:'so we know when to stop bugging you.', content:(
      <input type="time" value={data.windDown} onChange={e=>update('windDown',e.target.value)} style={{...inputStyle, fontSize:'1.2rem', fontFamily:"'Cormorant Garamond',serif", fontWeight:600}}/>
    )},
    { title:"What's your biggest daily struggle?", sub:'be honest — this is a safe space.', content:(
      <div style={{display:'flex', flexDirection:'column', gap:8}}>
        {['Getting out the door on time','Keeping up with meals','Finding time for myself','Staying organized','Balancing work and home','All of the above. Obviously.'].map(o=>(
          <button key={o} onClick={()=>update('biggestStruggle',o)} style={{...btnStyle, background:data.biggestStruggle===o?'#D4695A':THEME.cardBg, color:data.biggestStruggle===o?'white':THEME.text, border:'1px solid rgba(128,128,128,0.3)', padding:'0.55rem 1rem', textAlign:'left', borderRadius:12}}>{o}</button>
        ))}
      </div>
    )},
  ];
  const current = steps[step];
  const isLast = step === steps.length - 1;
  const colors = ['#D4695A','#5B9E8F','#C4985A','#8B7BA8'];
  const advance = () => { if (isLast) { onComplete(data); } else { setStep(s=>s+1); } };
  const handleKeyDown = (e) => { if (e.key === 'Enter' && step !== 1) advance(); };
  return (
    <div onKeyDown={handleKeyDown} style={{minHeight:'100vh', background:'#FAF7F2', display:'flex', alignItems:'center', justifyContent:'center', fontFamily:'Outfit,sans-serif', padding:'1rem'}}>
      <div style={{maxWidth:400, width:'100%'}}>
        <div style={{display:'flex', gap:4, marginBottom:'2rem'}}>
          {steps.map((_,i)=>(
            <div key={i} style={{flex:1, height:3, borderRadius:2, background:i<=step?colors[i%colors.length]:'rgba(128,128,128,0.2)', transition:'background 0.3s'}}/>
          ))}
        </div>
        <div style={{fontFamily:"'Cormorant Garamond',serif", fontSize:'1.8rem', fontWeight:600, color:THEME.text, lineHeight:1.2, marginBottom:'0.25rem'}}>{current.title}</div>
        <div style={{fontSize:'0.78rem', color:THEME.subtext, fontStyle:'italic', marginBottom:'1.5rem'}}>{current.sub}</div>
        <div style={{marginBottom:'2rem'}}>{current.content}</div>
        <div style={{display:'flex', justifyContent:'space-between', alignItems:'center'}}>
          {step > 0 ? <button onClick={()=>setStep(s=>s-1)} style={skipStyle}>Back</button> : <div/>}
          {step !== 1 && (
            <button onClick={advance} style={btnStyle}>
              {isLast ? "I'm ready — let's go" : 'Next'}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

function MySitch({ profile, onUpdate }) {
  const [editing, setEditing] = useState(false);
  const [local, setLocal] = useState(profile);
  const update = (key,val) => setLocal(p=>({...p,[key]:val}));
  const save = () => { onUpdate(local); setEditing(false); };
  const row = (label, value) => (
    <div style={{display:'flex', justifyContent:'space-between', alignItems:'center', padding:'0.75rem 0', borderBottom:'1px solid rgba(128,128,128,0.12)'}}>
      <span style={{fontSize:'0.78rem', color:THEME.subtext, fontWeight:500, textTransform:'uppercase', letterSpacing:'0.08em'}}>{label}</span>
      <span style={{fontSize:'0.9rem', color:THEME.text, fontWeight:400, textAlign:'right', maxWidth:'60%'}}>{value || '—'}</span>
    </div>
  );
  if (!profile) return null;
  return (
    <div>
      <div style={{display:'flex', alignItems:'baseline', justifyContent:'space-between', marginBottom:'0.25rem'}}>
        <div style={{fontFamily:"'Cormorant Garamond',serif", fontSize:'1.8rem', fontWeight:600}}>My Life (Bless It)</div>
        <button onClick={()=>setEditing(!editing)} style={{background:'none', border:'none', color:'#D4695A', fontFamily:'Outfit,sans-serif', fontSize:'0.78rem', fontWeight:500, cursor:'pointer'}}>{editing?'Cancel':'Edit'}</button>
      </div>
      <div style={{fontSize:'0.78rem', color:THEME.subtext, marginBottom:'1.5rem', fontStyle:'italic'}}>tell us what we're working with.</div>
      {!editing ? (
        <div style={{background:THEME.cardBg, borderRadius:16, padding:'0 1.25rem', border:'1px solid rgba(128,128,128,0.15)'}}>
          {row('Name', profile.name)}
          {row('Kids', profile.hasKids ? `Yes — ${profile.numKids}` : 'No kids at home')}
          {row('Work', profile.works)}
          {row('Wake up', profile.wakeTime)}
          {row('Wind down', profile.windDown)}
          {row('Biggest struggle', profile.biggestStruggle)}
        </div>
      ) : (
        <div style={{display:'flex', flexDirection:'column', gap:20}}>
          <div>
            <div style={{fontSize:'0.7rem', fontWeight:600, color:THEME.subtext, textTransform:'uppercase', letterSpacing:'0.1em', marginBottom:6}}>Name</div>
            <input value={local.name||''} onChange={e=>update('name',e.target.value)} style={{width:'100%', border:'none', borderBottom:'1.5px solid #D4695A', background:'none', fontFamily:'Outfit,sans-serif', fontSize:'16px', padding:'4px 0', color:THEME.text, outline:'none'}}/>
          </div>
          <div>
            <div style={{fontSize:'0.7rem', fontWeight:600, color:THEME.subtext, textTransform:'uppercase', letterSpacing:'0.1em', marginBottom:6}}>Kids at home</div>
            <div style={{display:'flex', gap:8}}>
              <button onClick={()=>update('hasKids',true)} style={{flex:1, background:local.hasKids?'#5B9E8F':THEME.cardBg, color:local.hasKids?'white':THEME.text, border:'1px solid rgba(128,128,128,0.3)', borderRadius:50, padding:'0.45rem 1rem', fontFamily:'Outfit,sans-serif', fontSize:'0.8rem', fontWeight:500, cursor:'pointer'}}>Yes</button>
              <button onClick={()=>{update('hasKids',false);update('numKids','');}} style={{flex:1, background:!local.hasKids?'#5B9E8F':THEME.cardBg, color:!local.hasKids?'white':THEME.text, border:'1px solid rgba(128,128,128,0.3)', borderRadius:50, padding:'0.45rem 1rem', fontFamily:'Outfit,sans-serif', fontSize:'0.8rem', fontWeight:500, cursor:'pointer'}}>No</button>
            </div>
          </div>
          {local.hasKids && <div>
            <div style={{fontSize:'0.7rem', fontWeight:600, color:THEME.subtext, textTransform:'uppercase', letterSpacing:'0.1em', marginBottom:6}}>How many</div>
            <div style={{display:'flex', gap:8}}>
              {['1','2','3','4','5+'].map(n=>(
                <button key={n} onClick={()=>update('numKids',n)} style={{background:local.numKids===n?'#8B7BA8':THEME.cardBg, color:local.numKids===n?'white':THEME.text, border:'1px solid rgba(128,128,128,0.3)', borderRadius:50, padding:'0.45rem 0.9rem', fontFamily:'Outfit,sans-serif', fontSize:'0.8rem', fontWeight:500, cursor:'pointer'}}>{n}</button>
              ))}
            </div>
          </div>}
          <div>
            <div style={{fontSize:'0.7rem', fontWeight:600, color:THEME.subtext, textTransform:'uppercase', letterSpacing:'0.1em', marginBottom:6}}>Work</div>
            <div style={{display:'flex', flexDirection:'column', gap:6}}>
              {['Full-time outside','Full-time remote','Part-time','Freelance / Self-employed','Stay at home','Student'].map(o=>(
                <button key={o} onClick={()=>update('works',o)} style={{background:local.works===o?'#C4985A':THEME.cardBg, color:local.works===o?'white':THEME.text, border:'1px solid rgba(128,128,128,0.3)', borderRadius:10, padding:'0.5rem 0.75rem', fontFamily:'Outfit,sans-serif', fontSize:'0.8rem', fontWeight:500, cursor:'pointer', textAlign:'left'}}>{o}</button>
              ))}
            </div>
          </div>
          <div>
            <div style={{fontSize:'0.7rem', fontWeight:600, color:THEME.subtext, textTransform:'uppercase', letterSpacing:'0.1em', marginBottom:6}}>Wake up</div>
            <input type="time" value={local.wakeTime||'06:30'} onChange={e=>update('wakeTime',e.target.value)} style={{border:'none', borderBottom:'1.5px solid #D4695A', background:'none', fontFamily:"'Cormorant Garamond',serif", fontSize:'1.2rem', fontWeight:600, padding:'4px 0', color:THEME.text, outline:'none'}}/>
          </div>
          <div>
            <div style={{fontSize:'0.7rem', fontWeight:600, color:THEME.subtext, textTransform:'uppercase', letterSpacing:'0.1em', marginBottom:6}}>Wind down</div>
            <input type="time" value={local.windDown||'21:00'} onChange={e=>update('windDown',e.target.value)} style={{border:'none', borderBottom:'1.5px solid #D4695A', background:'none', fontFamily:"'Cormorant Garamond',serif", fontSize:'1.2rem', fontWeight:600, padding:'4px 0', color:THEME.text, outline:'none'}}/>
          </div>
          <div>
            <div style={{fontSize:'0.7rem', fontWeight:600, color:THEME.subtext, textTransform:'uppercase', letterSpacing:'0.1em', marginBottom:6}}>Biggest struggle</div>
            <div style={{display:'flex', flexDirection:'column', gap:6}}>
              {['Getting out the door on time','Keeping up with meals','Finding time for myself','Staying organized','Balancing work and home','All of the above. Obviously.'].map(o=>(
                <button key={o} onClick={()=>update('biggestStruggle',o)} style={{background:local.biggestStruggle===o?'#D4695A':THEME.cardBg, color:local.biggestStruggle===o?'white':THEME.text, border:'1px solid rgba(128,128,128,0.3)', borderRadius:10, padding:'0.5rem 0.75rem', fontFamily:'Outfit,sans-serif', fontSize:'0.8rem', fontWeight:500, cursor:'pointer', textAlign:'left'}}>{o}</button>
              ))}
            </div>
          </div>
          <button onClick={save} style={{background:'#D4695A', color:'white', border:'none', borderRadius:50, padding:'0.65rem 1.5rem', fontFamily:'Outfit,sans-serif', fontSize:'0.9rem', fontWeight:500, cursor:'pointer', alignSelf:'flex-start'}}>Save changes</button>
        </div>
      )}
    </div>
  );
}

export default function App({ user, setUser, guestMode, setGuestMode }) {
  const [showMorning, setShowMorning] = useState(false);
  const [showEvening, setShowEvening] = useState(false);
  const [tab, setTab] = useState('matrix');
  const [tasks, setTasks] = useState({ do:[], schedule:[], delegate:[], let:[] });
  const [habits, setHabits] = useState([]);
  const [profile, setProfile] = useState(() => {
    try { const s = localStorage.getItem('clearedProfile'); return s ? JSON.parse(s) : null; } catch(e) { return null; }
  });
  const [grocery, setGroceryState] = useState(() => {
    try { const s = localStorage.getItem('clearedGrocery'); return s ? JSON.parse(s) : []; } catch(e) { return []; }
  });
  const setGrocery = (next) => { setGroceryState(next); localStorage.setItem('clearedGrocery', JSON.stringify(next)); };
  const [theme, setThemeState] = useState(() => {
    const saved = localStorage.getItem('clearedTheme');
    return (saved && THEMES[saved]) ? saved : 'deepsea';
  });
  const setTheme = (name) => { applyTheme(name); localStorage.setItem('clearedTheme', name); setThemeState(name); };
  const [isPremium] = useState(true); // BETA: all features unlocked
  const [showUpgrade, setShowUpgrade] = useState(false);
  const [themePreview, setThemePreview] = useState(null);
  useEffect(() => {
    // BETA: Stripe checkout handling preserved for post-beta
    const params = new URLSearchParams(window.location.search);
    if (params.get('checkout') === 'success') {
      // setIsPremium(true);
      localStorage.setItem('clearedPremium', 'true');
      window.history.replaceState({}, '', window.location.pathname);
    }
  }, []);
  // STRIPE CHECKOUT — preserved for post-beta launch
  // const handleUpgrade = async () => {
  //   try {
  //     const res = await fetch('/api/create-checkout-session', {
  //       method: 'POST',
  //       headers: { 'Content-Type': 'application/json' },
  //       body: JSON.stringify({ userId: user?.id, email: user?.email }),
  //     });
  //     const data = await res.json();
  //     if (data.url) window.location.href = data.url;
  //     else alert(data.error || 'Could not start checkout.');
  //   } catch (e) { alert('Checkout failed — please try again.'); }
  // };
  const showBetaToast = () => {
    if (toastTimer.current) clearTimeout(toastTimer.current);
    setToast({show:true, msg:"You're in beta", sub:"All features unlocked 💜"});
    toastTimer.current = setTimeout(()=>setToast(t=>({...t,show:false})),2500);
  };
  const handleUpgrade = () => { showBetaToast(); }; // BETA: toast instead of Stripe
  const [quote] = useState(()=>randomFrom(QUOTES));
  const [toast, setToast] = useState({show:false,msg:'',sub:''});
  const [confetti, setConfetti] = useState(false);
  const [completedCount, setCompletedCount] = useState(0);
  const [dumpText, setDumpText] = useState('');
  const [sorting, setSorting] = useState(false);
  const [sortError, setSortError] = useState(null);
  const [sortedPreview, setSortedPreview] = useState([]);
  const toastTimer = useRef(null);
  const tasksLoaded = useRef(false);

  // Load tasks, habits, and profile when user is available
  useEffect(() => {
    if (!user) return;
    console.log('[Load] Loading data for user:', user.id);
    const loadData = async () => {
      const [tasksRes, habitsRes, profileRes] = await Promise.all([
        supabase.from('tasks').select('*').eq('user_id', user.id),
        supabase.from('habits').select('*').eq('user_id', user.id),
        supabase.from('profile').select('*').eq('user_id', user.id).maybeSingle(),
      ]);
      console.log('[Load] Tasks response:', { data: tasksRes.data?.length || 0, error: tasksRes.error });
      if (tasksRes.error) console.error('Load tasks error:', tasksRes.error);
      if (tasksRes.data?.length) {
        const grouped = { do:[], schedule:[], delegate:[], let:[] };
        tasksRes.data.forEach(t => {
          if (grouped[t.quadrant]) {
            grouped[t.quadrant].push({ id:t.id, text:t.text, done:t.done, aiSorted:t.ai_sorted || false });
          }
        });
        console.log('[Load] Grouped tasks:', Object.entries(grouped).map(([k,v])=>`${k}:${v.length}`).join(', '));
        setTasks(grouped);
      } else {
        console.log('[Load] No tasks found for user');
      }
      tasksLoaded.current = true;
      console.log('[Load] Habits:', habitsRes.data?.length || 0, 'error:', habitsRes.error || 'none');
      if (habitsRes.data?.length) {
        setHabits(habitsRes.data.map(h => ({ id:h.id, name:h.name, streak:h.streak, checked:h.checked, color:h.color })));
      }
      console.log('[Load] Profile:', profileRes.data ? 'found' : 'none', 'error:', profileRes.error || 'none');
      if (profileRes.data) {
        const d = profileRes.data;
        const p = { name:d.name, hasKids:d.has_kids, numKids:d.num_kids, works:d.works, wakeTime:d.wake_time, windDown:d.wind_down, biggestStruggle:d.biggest_struggle, morning_items:d.morning_items, evening_items:d.evening_items, leave_time:d.leave_time };
        setProfile(p);
        localStorage.setItem('clearedProfile', JSON.stringify(p));
      }
    };
    loadData();
  }, [user]);

  useEffect(() => {
    const hr = new Date().getHours();
    if (hr >= 5 && hr < 10) setShowMorning(true);
  }, []);

  const now = new Date();
  const dateStr = now.toLocaleDateString('en-US',{month:'long',day:'numeric'});
  const dayStr = now.toLocaleDateString('en-US',{weekday:'long'});

  const showToast = () => {
    const cel = randomFrom(CELEBRATIONS);
    if (toastTimer.current) clearTimeout(toastTimer.current);
    setConfetti(true);
    setToast({show:true,msg:cel.msg,sub:cel.sub});
    setTimeout(()=>setConfetti(false),2500);
    toastTimer.current = setTimeout(()=>setToast(t=>({...t,show:false})),2200);
  };

  const toggleTask = (q,i) => {
    setTasks(prev => {
      const updated = [...prev[q]];
      updated[i] = {...updated[i], done:!updated[i].done};
      if (!prev[q][i].done) { setCompletedCount(c=>c+1); showToast(); }
      if (user) {
        supabase.from('tasks').update({ done: updated[i].done }).eq('id', updated[i].id).then(({error})=>{ if (error) console.error('Toggle task error:', error); });
      }
      const sorted = [...updated].sort((a,b) => (a.done === b.done) ? 0 : a.done ? 1 : -1);
      return {...prev,[q]:sorted};
    });
  };

  const editTask = (q, i, newText) => {
    setTasks(prev => {
      const updated = [...prev[q]];
      updated[i] = {...updated[i], text: newText};
      if (user && updated[i].id) {
        supabase.from('tasks').update({ text: newText }).eq('id', updated[i].id).then(({error})=>{ if (error) console.error('Edit task error:', error); });
      }
      return {...prev, [q]: updated};
    });
  };

  const reorderTask = (q, fromIdx, toIdx) => {
    setTasks(prev => {
      const arr = [...prev[q]];
      const [moved] = arr.splice(fromIdx, 1);
      arr.splice(toIdx, 0, moved);
      return {...prev, [q]: arr};
    });
  };

  const deleteTask = (q,i) => {
    setTasks(prev => {
      const task = prev[q][i];
      if (user && task?.id) {
        console.log('Deleting task id:', task.id, 'type:', typeof task.id);
        supabase.from('tasks').delete().eq('id', task.id).select().then(({data, error})=>{
          if (error) console.error('Delete task error:', error);
          else console.log('Delete returned rows:', data);
        });
      }
      return {...prev, [q]: prev[q].filter((_,idx)=>idx!==i)};
    });
  };

  const idCounter = useRef(0);
  const nextId = () => Date.now() * 1000 + (idCounter.current++ % 1000);
  const addTask = async (q,text,aiSorted=false) => {
    const tempId = nextId();
    console.log('[Task] Adding task:', q, text, 'id:', tempId, 'user:', user?.id || 'guest');
    setTasks(prev=>({...prev,[q]:[...prev[q],{text,done:false,id:tempId,aiSorted}]}));
    if (user) {
      const { data, error } = await supabase.from('tasks').insert({ id: tempId, user_id: user.id, quadrant: q, text, done: false }).select().single();
      console.log('[Task] Insert result:', { data, error });
      if (error) { console.error('Insert task error:', error); return; }
      if (data && data.id !== tempId) {
        console.log('[Task] ID remapped:', tempId, '->', data.id);
        setTasks(prev => ({...prev, [q]: prev[q].map(t => t.id === tempId ? {...t, id: data.id} : t)}));
      }
    }
  };

  const colorMap = {do:'coral',schedule:'teal',delegate:'gold',let:'plum'};

  const getAiSortCount = () => {
    try {
      const today = new Date().toISOString().slice(0,10);
      const stored = JSON.parse(localStorage.getItem('clearedAiSort') || '{}');
      return stored.date === today ? (stored.count || 0) : 0;
    } catch(e) { return 0; }
  };
  const aiSort = async () => {
    const lines = dumpText.split('\n').map(l=>l.trim()).filter(Boolean);
    console.log('[AI Sort] lines:', lines.length, 'isPremium:', isPremium);
    if (!lines.length) { console.log('[AI Sort] No lines, returning'); return; }
    if (!isPremium) {
      const count = getAiSortCount();
      console.log('[AI Sort] Free user sort count today:', count, 'limit: 3');
      if (count >= 3) { console.log('[AI Sort] BLOCKED — limit reached'); setShowUpgrade(true); return; }
      console.log('[AI Sort] ALLOWED — sort', count + 1, 'of 3');
    } else {
      console.log('[AI Sort] Pro user — unlimited');
    }
    setSorting(true); setSortedPreview([]); setSortError(null);
    try {
      console.log('[AI Sort] Calling /api/sort...');
      const res = await fetch('/api/sort', {
        method:'POST',
        headers:{'Content-Type':'application/json'},
        body:JSON.stringify({ tasks: lines })
      });
      console.log('[AI Sort] Response status:', res.status);
      if (!res.ok) {
        const errBody = await res.text();
        console.error('[AI Sort] API error body:', errBody);
        throw new Error(`API returned ${res.status}: ${errBody}`);
      }
      const data = await res.json();
      console.log('[AI Sort] Response data:', data);
      const sorted = Array.isArray(data) ? data : data.sorted || data.result;
      if (!Array.isArray(sorted)) throw new Error('Invalid response format');
      setSortedPreview(sorted);
      setDumpText('');
      if (!isPremium) {
        const today = new Date().toISOString().slice(0,10);
        const count = getAiSortCount();
        localStorage.setItem('clearedAiSort', JSON.stringify({ date: today, count: count + 1 }));
        console.log('[AI Sort] Updated count to', count + 1);
      }
    } catch(e) { console.error('[AI Sort] Error:', e.message); setSortError(e.message); }
    setSorting(false);
  };

  const commitToMatrix = () => {
    const groceryItems = sortedPreview.filter(item=>item.quadrant==='grocery');
    const taskItems = sortedPreview.filter(item=>item.quadrant!=='grocery');
    if (groceryItems.length) {
      const newGrocery = [...grocery, ...groceryItems.map(g=>({ id:Date.now()+Math.floor(Math.random()*1000), text:g.task, done:false }))];
      setGrocery(newGrocery);
    }
    taskItems.forEach(item=>addTask(item.quadrant,item.task,true));
    setSortedPreview([]); setTab('matrix');
  };

  const manualSort = () => {
    const lines = dumpText.split('\n').map(l=>l.trim()).filter(Boolean);
    setSortedPreview(lines.map(task=>({task,quadrant:''})));
    setDumpText('');
  };

  const profileToRow = (p, uid) => ({
    user_id: uid, name: p.name, has_kids: p.hasKids, num_kids: p.numKids,
    works: p.works, wake_time: p.wakeTime, wind_down: p.windDown, biggest_struggle: p.biggestStruggle
  });

  const handleProfileUpdate = async (p) => {
    setProfile(p);
    localStorage.setItem('clearedProfile', JSON.stringify(p));
    if (user) {
      const { error } = await supabase.from('profile').upsert(profileToRow(p, user.id), { onConflict: 'user_id' });
      if (error) console.error('Save profile error:', error);
    }
  };

  const handleOnboardingComplete = async (data) => {
    setProfile(data);
    localStorage.setItem('clearedProfile', JSON.stringify(data));
    if (user) {
      const { error } = await supabase.from('profile').upsert(profileToRow(data, user.id), { onConflict: 'user_id' });
      if (error) console.error('Save profile error:', error);
    }
  };

  const TABS = ['matrix','daily','dump'];
  const ROW2 = ['habits','sitch'];

  if (showMorning) {
    return (
      <>
        <style>{`
          @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;0,600;1,300;1,400&family=Outfit:wght@300;400;500;600&display=swap');
          *{box-sizing:border-box;margin:0;padding:0;} body{overflow-x:hidden;} .back-btn{background:#D4695A !important;color:white !important;border:none !important;border-radius:50px !important;padding:8px 20px !important;font-family:Outfit,sans-serif !important;font-size:13px !important;font-weight:500 !important;cursor:pointer !important;}
          body{font-family:'Outfit',sans-serif;background:#FAF7F2;color:${THEME.text};}
          @keyframes fall{0%{transform:translateY(0) rotate(0deg);opacity:1}80%{opacity:1}100%{transform:translateY(100vh) rotate(540deg) scale(0.6);opacity:0}}
          @keyframes spin{to{transform:rotate(360deg)}}
        `}</style>
        <MorningCommandCenter onDismiss={()=>setShowMorning(false)} userId={user?.id} profile={profile} onProfileChange={setProfile}/>
      </>
    );
  }

  if (showEvening) {
    return (
      <>
        <style>{`
          @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;0,600;1,300;1,400&family=Outfit:wght@300;400;500;600&display=swap');
          *{box-sizing:border-box;margin:0;padding:0;} body{overflow-x:hidden;}
          body{font-family:'Outfit',sans-serif;background:#FAF7F2;color:${THEME.text};}
          @keyframes fall{0%{transform:translateY(0) rotate(0deg);opacity:1}80%{opacity:1}100%{transform:translateY(100vh) rotate(540deg) scale(0.6);opacity:0}}
          @keyframes spin{to{transform:rotate(360deg)}}
        `}</style>
        <EveningCommandCenter onDismiss={()=>setShowEvening(false)} userId={user?.id} profile={profile} onProfileChange={setProfile}/>
      </>
    );
  }

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;0,600;1,300;1,400&family=Outfit:wght@300;400;500;600&display=swap');
        *{box-sizing:border-box;margin:0;padding:0;}
        html,body,#root{width:100%;max-width:100vw;min-height:100vh;margin:0;padding:0;overflow-x:hidden;background:#FAF7F2;}
        body{font-family:'Outfit',sans-serif;color:${THEME.text};}
        @keyframes fall{0%{transform:translateY(0) rotate(0deg);opacity:1}80%{opacity:1}100%{transform:translateY(100vh) rotate(540deg) scale(0.6);opacity:0}}
        @keyframes spin{to{transform:rotate(360deg)}}
        input[type="time"]::-webkit-calendar-picker-indicator{filter:none;}
        @media (max-width:640px){
          .main-content{max-width:100% !important;padding:0.75rem 0.5rem !important;}
          .navbar{padding:0.75rem 1rem !important;}
          .quadrant-grid{gap:6px !important;}
          .quadrant-grid > div{padding:0.75rem 0.6rem !important;min-height:160px !important;}
          .theme-picker-mobile{display:flex !important;}
          .theme-picker-desktop{display:none !important;}
        }
      `}</style>

      <Confetti active={confetti}/>
      <Toast show={toast.show} msg={toast.msg} sub={toast.sub}/>
      {showUpgrade && (
        <div onClick={()=>setShowUpgrade(false)} style={{position:'fixed', inset:0, background:'rgba(15,15,15,0.55)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:1000, padding:'1rem'}}>
          <div onClick={e=>e.stopPropagation()} style={{background:THEME.cardBg, borderRadius:20, padding:'2rem 1.75rem', maxWidth:380, width:'100%', border:`1.5px solid ${COLOR.gold.border}`, textAlign:'center'}}>
            <div style={{fontSize:'2rem', marginBottom:8}}>✨</div>
            <div style={{fontFamily:"'Cormorant Garamond',serif", fontSize:'1.6rem', fontWeight:600, color:THEME.text, marginBottom:6}}>Upgrade to Pro</div>
            <div style={{fontSize:'0.8rem', color:THEME.subtext, marginBottom:'1.25rem', lineHeight:1.5}}>You've hit the free limit. Upgrade to unlock:</div>
            <ul style={{listStyle:'none', textAlign:'left', fontSize:'0.82rem', color:THEME.text, lineHeight:1.9, marginBottom:'1.5rem', paddingLeft:4}}>
              <li>✓ Unlimited AI Brain Dump sorts</li>
              <li>✓ Unlimited habits</li>
              <li>✓ Priority support</li>
            </ul>
            <div style={{fontFamily:"'Cormorant Garamond',serif", fontSize:'1.4rem', fontWeight:600, color:COLOR.gold.dark, marginBottom:'1.25rem'}}>$9.99<span style={{fontSize:'0.75rem', color:THEME.subtext, fontWeight:400, fontFamily:'Outfit,sans-serif'}}> / month</span></div>
            <button onClick={handleUpgrade} style={{width:'100%', background:COLOR.gold.main, color:'white', border:'none', borderRadius:50, padding:'0.75rem', fontFamily:'Outfit,sans-serif', fontSize:'0.85rem', fontWeight:600, cursor:'pointer', marginBottom:8}}>Upgrade to Pro</button>
            <button onClick={()=>setShowUpgrade(false)} style={{background:'none', border:'none', color:THEME.subtext, fontFamily:'Outfit,sans-serif', fontSize:'0.78rem', cursor:'pointer', textDecoration:'underline'}}>Maybe later</button>
          </div>
        </div>
      )}
      {themePreview && (() => {
        const t = THEMES[themePreview];
        if (!t) return null;
        const c = t.colors;
        return (
          <div onClick={()=>setThemePreview(null)} style={{position:'fixed', inset:0, background:'rgba(15,15,15,0.55)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:1001, padding:'1rem'}}>
            <div onClick={e=>e.stopPropagation()} style={{background:THEME.cardBg, borderRadius:20, padding:'1.75rem 1.5rem', maxWidth:360, width:'100%', border:'1px solid rgba(128,128,128,0.15)', textAlign:'center'}}>
              <div style={{fontFamily:"'Cormorant Garamond',serif", fontSize:'1.4rem', fontWeight:600, color:THEME.text, marginBottom:4}}>{t.label}</div>
              <div style={{fontSize:'0.75rem', color:THEME.subtext, marginBottom:'1.25rem', fontStyle:'italic'}}>Pro color scheme</div>
              <div style={{display:'grid', gridTemplateColumns:'1fr 1fr', gap:8, marginBottom:'1.5rem'}}>
                {Object.entries(c).map(([key,v])=>(
                  <div key={key} style={{background:v.bg, border:`1.5px solid ${v.border}`, borderRadius:12, padding:'0.9rem 0.75rem', textAlign:'left'}}>
                    <div style={{width:10, height:10, borderRadius:'50%', background:v.main, marginBottom:6}}/>
                    <div style={{fontSize:'0.6rem', fontWeight:600, letterSpacing:'0.1em', textTransform:'uppercase', color:v.dark}}>{QUADRANTS.find(q=>q.color===key)?.label||key}</div>
                  </div>
                ))}
              </div>
              <div style={{background:t.bodyBg, borderRadius:10, padding:'0.6rem', marginBottom:'1.25rem', border:'1px solid rgba(128,128,128,0.15)'}}>
                <div style={{fontSize:'0.65rem', color:t.subtext, textTransform:'uppercase', letterSpacing:'0.1em'}}>Background</div>
              </div>
              <button onClick={()=>{setThemePreview(null);handleUpgrade();}} style={{width:'100%', background:c.coral.main, color:'white', border:'none', borderRadius:50, padding:'0.75rem', fontFamily:'Outfit,sans-serif', fontSize:'0.85rem', fontWeight:600, cursor:'pointer', marginBottom:8}}>Unlock with Pro</button>
              <button onClick={()=>setThemePreview(null)} style={{background:'none', border:'none', color:THEME.subtext, fontFamily:'Outfit,sans-serif', fontSize:'0.78rem', cursor:'pointer', textDecoration:'underline'}}>Not now</button>
            </div>
          </div>
        );
      })()}

      <div className="navbar" style={{background:THEME.cardBg, borderBottom:'1px solid rgba(128,128,128,0.15)', padding:'0.9rem 1.25rem', position:'sticky', top:0, zIndex:100, boxSizing:'border-box', width:'100%', display:'flex', flexDirection:'column', gap:10}}>
        <div style={{display:'flex', alignItems:'center', justifyContent:'space-between', gap:8}}>
          <div>
            <div onClick={()=>setTab('matrix')} style={{fontFamily:"'Cormorant Garamond',serif", fontSize:'1.75rem', fontWeight:600, letterSpacing:'0.04em', cursor:'pointer', transition:'opacity 0.2s'}} onMouseEnter={e=>e.target.style.opacity='0.7'} onMouseLeave={e=>e.target.style.opacity='1'}>Cleared<span style={{color:'#D4695A'}}>.</span></div>
            <div style={{fontSize:'0.68rem', color:THEME.subtext, fontWeight:300, letterSpacing:'0.12em', textTransform:'uppercase', marginTop:1}}>Quiet the noise. Find your clear.</div>
          </div>
          <span className="theme-picker-mobile" style={{display:'none'}}><ThemePicker theme={theme} setTheme={setTheme} compact /></span>
          <div style={{display:'flex', alignItems:'center', gap:6, flexShrink:0}}>
            <button onClick={()=>{supabase.auth.signOut(); setUser(null); localStorage.removeItem('clearedGuestMode'); setGuestMode(false);}} style={{background:'none', color:THEME.subtext, border:'1px solid rgba(128,128,128,0.3)', borderRadius:50, padding:'0.4rem 1rem', fontFamily:'Outfit,sans-serif', fontSize:'0.72rem', fontWeight:500, cursor:'pointer'}}>Sign Out</button>
          </div>
        </div>
        <div className="navbar-row2" style={{display:'flex', gap:8, alignItems:'center', flexWrap:'wrap'}}>
          <span className="theme-picker-desktop"><ThemePicker theme={theme} setTheme={setTheme} /></span>
          <button onClick={()=>setShowMorning(true)} style={{background:COLOR.coral.bg, color:COLOR.coral.dark, border:'none', borderRadius:50, padding:'0.4rem 1rem', fontFamily:'Outfit,sans-serif', fontSize:'0.72rem', fontWeight:500, cursor:'pointer'}}>☀ Morning</button>
          <button onClick={()=>setShowEvening(true)} style={{background:COLOR.plum.bg, color:COLOR.plum.dark, border:'none', borderRadius:50, padding:'0.4rem 1rem', fontFamily:'Outfit,sans-serif', fontSize:'0.72rem', fontWeight:500, cursor:'pointer'}}>🌙 Evening</button>
          <button onClick={showBetaToast} style={{background:'#9BA4E0', color:'white', border:'none', borderRadius:50, padding:'0.35rem 0.9rem', fontFamily:'Outfit,sans-serif', fontSize:'0.68rem', fontWeight:600, letterSpacing:'0.04em', cursor:'pointer'}}>✨ Beta</button>
        </div>
      </div>

      <div style={{display:'flex', background:THEME.cardBg, borderBottom:'1px solid rgba(128,128,128,0.15)', padding:'0 1.5rem', overflowX:'auto'}}>
        {TABS.map(t=>(
          <button key={t} onClick={()=>setTab(t)} style={{padding:'0.75rem 1.25rem', fontSize:'0.8rem', fontWeight:500, letterSpacing:'0.06em', textTransform:'uppercase', color:tab===t?THEME.text:THEME.subtext, cursor:'pointer', border:'none', background:'none', borderBottom:tab===t?'2px solid #D4695A':'2px solid transparent', fontFamily:'Outfit,sans-serif', transition:'color 0.2s', whiteSpace:'nowrap'}}>
            {t==='dump'?'Brain Dump':t.charAt(0).toUpperCase()+t.slice(1)}
          </button>
        ))}
        </div>
      <div style={{display:'flex', background:THEME.cardBg, borderBottom:'1px solid rgba(128,128,128,0.15)', padding:'0 1.5rem', overflowX:'auto'}}>
        {ROW2.map(t=>(
          <button key={t} onClick={()=>setTab(t)} style={{padding:'0.75rem 1.25rem', fontSize:'0.8rem', fontWeight:500, letterSpacing:'0.06em', textTransform:'uppercase', color:tab===t?THEME.text:THEME.subtext, cursor:'pointer', border:'none', background:'none', borderBottom:tab===t?'2px solid #D4695A':'2px solid transparent', fontFamily:'Outfit,sans-serif', transition:'color 0.2s', whiteSpace:'nowrap'}}>
            {t==='sitch'?'The Sitch':t.charAt(0).toUpperCase()+t.slice(1)}
          </button>
        ))}
        </div>

<div className="main-content" style={{padding:'1rem 0.75rem', maxWidth:900, margin:'0 auto', overflowX:'hidden', width:'100%', boxSizing:'border-box'}}>        {tab==='matrix' && (
          <>
            <div style={{background:THEME.cardBg, borderRadius:12, padding:'1rem 1.25rem', marginBottom:'1.5rem', borderLeft:'3px solid #D4838F'}}>
              <div style={{fontFamily:"'Cormorant Garamond',serif", fontStyle:'italic', fontSize:'0.95rem', color:THEME.text, lineHeight:1.5}}>{quote}</div>
            </div>
            <div style={{fontFamily:"'Cormorant Garamond',serif", fontSize:'1.6rem', fontWeight:300, marginBottom:'0.25rem'}}>Your Life List</div>
            <div style={{fontSize:'0.78rem', color:THEME.subtext, marginBottom:'1.5rem', fontWeight:300}}>Drop it in the right bucket — color is your guide.</div>
            <div className="quadrant-grid" style={{display:'grid', gridTemplateColumns:'repeat(2, minmax(0, 1fr))', gap:8}}>
              {QUADRANTS.map(q=><Quadrant key={q.key} q={q} tasks={tasks[q.key]} onToggle={toggleTask} onAdd={addTask} onDelete={deleteTask} onEdit={editTask} onReorder={reorderTask} grocery={grocery} setGrocery={setGrocery}/>)}
            </div>
          </>
        )}

        {tab==='daily' && (
          <>
            <div style={{display:'flex', alignItems:'baseline', gap:'0.75rem', marginBottom:'1.5rem'}}>
              <div style={{fontFamily:"'Cormorant Garamond',serif", fontSize:'2.2rem', fontWeight:300}}>{dateStr}</div>
              <div style={{fontSize:'0.75rem', color:THEME.subtext, fontWeight:300, letterSpacing:'0.1em', textTransform:'uppercase'}}>{dayStr}</div>
            </div>
            {QUADRANTS.map(q=>(
              <div key={q.key} style={{marginBottom:'1.5rem'}}>
                <div style={{display:'flex', alignItems:'center', gap:8, marginBottom:'0.6rem'}}>
                  <div style={{width:8, height:8, borderRadius:'50%', background:COLOR[q.color].main}}/>
                  <div style={{fontSize:'0.65rem', fontWeight:600, letterSpacing:'0.14em', textTransform:'uppercase', color:THEME.subtext}}>{q.label}</div>
                </div>
                {tasks[q.key].map((task,i)=>(
                  <div key={task.id} style={{display:'flex', alignItems:'center', gap:10, padding:'0.6rem 0', borderBottom:'1px solid rgba(128,128,128,0.12)'}}>
                    <div onClick={()=>toggleTask(q.key,i)} style={{width:20, height:20, borderRadius:'50%', cursor:'pointer', flexShrink:0, display:'flex', alignItems:'center', justifyContent:'center', fontSize:10, color:'white', background:task.done?COLOR[q.color].main:'none', border:task.done?`1.5px solid ${COLOR[q.color].main}`:'1.5px solid rgba(128,128,128,0.35)'}}>{task.done?'✓':''}</div>
                    <span style={{fontSize:'0.88rem', color:task.done?THEME.subtext:THEME.text, flex:1, textDecoration:task.done?'line-through':'none'}}>{task.text}</span>
                    <button onClick={()=>deleteTask(q.key,i)} style={{background:'none', border:'none', cursor:'pointer', fontSize:'1rem', color:THEME.subtext, padding:'0 2px', flexShrink:0, lineHeight:1}}>×</button>
                  </div>
                ))}
              </div>
            ))}
            <div style={{background:'linear-gradient(135deg,#f5e8e6,#ede9f5)', borderRadius:14, padding:'1.25rem 1.5rem', marginTop:'1.5rem', textAlign:'center', border:'1px solid rgba(212,105,90,0.12)'}}>
              <div style={{fontFamily:"'Cormorant Garamond',serif", fontSize:'2.8rem', fontWeight:600, color:'#D4695A', lineHeight:1}}>{completedCount}</div>
              <div style={{fontSize:'0.78rem', color:THEME.subtext, marginTop:4, fontWeight:300}}>tasks cleared this session — your invisible work, made visible.</div>
            </div>
          </>
        )}

        {tab==='dump' && (
          <>
            <div style={{background:THEME.cardBg, borderRadius:16, padding:'1.5rem', border:'1px solid rgba(128,128,128,0.15)'}}>
              <div style={{fontFamily:"'Cormorant Garamond',serif", fontStyle:'italic', fontSize:'1rem', color:THEME.subtext, marginBottom:'1rem', lineHeight:1.6}}>"No judgment here. Just get it out of your head and onto the page. Every single thing."</div>
              <textarea value={dumpText} onChange={e=>setDumpText(e.target.value)} placeholder="What's swirling around in your head? Just type it all out — one thing per line. The AI will figure out where it goes." style={{width:'100%', minHeight:180, border:'1.5px solid rgba(128,128,128,0.2)', borderRadius:12, padding:'1rem', fontFamily:'Outfit,sans-serif', fontSize:'0.88rem', color:THEME.text, background:'#FAF7F2', resize:'none', outline:'none', lineHeight:1.7}}/>
              <div style={{display:'flex', justifyContent:'space-between', alignItems:'center', marginTop:'1rem', flexWrap:'wrap', gap:8}}>
                <div>
                  <span style={{fontSize:'0.75rem', color:THEME.subtext, fontStyle:'italic'}}>{dumpText.split('\n').filter(l=>l.trim()).length} items</span>
                  {!isPremium && <span style={{fontSize:'0.68rem', color:THEME.subtext, marginLeft:12}}>AI sorts today: {getAiSortCount()}/3</span>}
                </div>
                <div style={{display:'flex', gap:8}}>
                  <button onClick={manualSort} style={{background:'none', color:THEME.subtext, border:'1px solid rgba(128,128,128,0.35)', borderRadius:50, padding:'0.5rem 1.2rem', fontFamily:'Outfit,sans-serif', fontSize:'0.78rem', cursor:'pointer'}}>Sort it myself</button>
                  <button onClick={aiSort} disabled={sorting} style={{background:'#D4695A', color:'white', border:'none', borderRadius:50, padding:'0.55rem 1.4rem', fontFamily:'Outfit,sans-serif', fontSize:'0.8rem', fontWeight:500, cursor:'pointer', opacity:sorting?0.6:1, display:'flex', alignItems:'center', gap:6}}>
                    {sorting?'✨ Sorting...':'✨ AI Sort it'}
                  </button>
                </div>
              </div>
              {sorting && (
                <div style={{display:'flex', alignItems:'center', gap:10, padding:'0.9rem 1.1rem', background:'#FAF7F2', borderRadius:12, marginTop:'1rem'}}>
                  <div style={{width:18, height:18, border:'2px solid rgba(212,105,90,0.2)', borderTopColor:'#D4695A', borderRadius:'50%', animation:'spin 0.8s linear infinite'}}/>
                  <span style={{fontSize:'0.8rem', color:THEME.subtext, fontStyle:'italic'}}>Thinking through your list...</span>
                </div>
              )}
              {sortError && (
                <div style={{background:'#F5E8E6', borderRadius:12, padding:'0.9rem 1.1rem', marginTop:'1rem', border:'1px solid rgba(212,105,90,0.2)'}}>
                  <div style={{fontSize:'0.8rem', color:'#8B3A2E', fontWeight:500, marginBottom:4}}>AI Sort failed</div>
                  <div style={{fontSize:'0.72rem', color:THEME.subtext, lineHeight:1.4}}>{sortError}</div>
                  <button onClick={()=>setSortError(null)} style={{background:'none', border:'none', color:'#D4695A', fontFamily:'Outfit,sans-serif', fontSize:'0.72rem', cursor:'pointer', textDecoration:'underline', marginTop:6, padding:0}}>Dismiss</button>
                </div>
              )}
            </div>
            {sortedPreview.length>0 && (
              <div style={{marginTop:'1.25rem', display:'flex', flexDirection:'column', gap:8}}>
                {sortedPreview.map((item,i)=>(
                  <div key={i} style={{display:'flex', alignItems:'center', gap:10, background:THEME.cardBg, borderRadius:10, padding:'0.65rem 1rem', border:'1px solid rgba(128,128,128,0.15)'}}>
                    <div style={{width:10, height:10, borderRadius:'50%', background:item.quadrant==='grocery'?'#C4985A':(item.quadrant?COLOR[colorMap[item.quadrant]]?.main:'#ccc'), flexShrink:0}}/>
                    <span style={{flex:1, fontSize:'0.83rem', color:THEME.text}}>{item.task}</span>
                    <select value={item.quadrant||''} onChange={e=>{const q=e.target.value;setSortedPreview(prev=>{const u=[...prev];u[i]={...u[i],quadrant:q};return u;});}} style={{border:`1px solid ${item.quadrant&&item.quadrant!=='grocery'?COLOR[colorMap[item.quadrant]]?.border:'rgba(128,128,128,0.3)'}`, borderRadius:50, padding:'0.3rem 0.6rem', fontFamily:'Outfit,sans-serif', fontSize:'0.68rem', fontWeight:600, background:item.quadrant&&item.quadrant!=='grocery'?COLOR[colorMap[item.quadrant]]?.bg:THEME.bodyBg, color:item.quadrant&&item.quadrant!=='grocery'?COLOR[colorMap[item.quadrant]]?.dark:THEME.text, outline:'none', cursor:'pointer', flexShrink:0}}>
                      <option value="">Sort to...</option>
                      <option value="do">Do Right Now</option>
                      <option value="schedule">Call & Schedule</option>
                      <option value="delegate">Shop & Errands</option>
                      <option value="let">Do at Home</option>
                      <option value="grocery">🛒 Grocery</option>
                    </select>
                  </div>
                ))}
                <button onClick={commitToMatrix} style={{background:'#5B9E8F', color:'white', border:'none', borderRadius:50, padding:'0.55rem 1.4rem', fontFamily:'Outfit,sans-serif', fontSize:'0.8rem', fontWeight:500, cursor:'pointer', alignSelf:'flex-end', marginTop:4}}>Add to my matrix →</button>
              </div>
            )}
          </>
        )}

        {tab==='habits' && <HabitTracker showToast={showToast} userId={user?.id} initialHabits={habits} isPremium={isPremium} onUpgrade={()=>setShowUpgrade(true)}/>}

        {tab==='sitch' && (profile ? <MySitch profile={profile} onUpdate={handleProfileUpdate}/> : <Onboarding onComplete={handleOnboardingComplete}/>)}
      </div>
    </>
  );
}

// PALETTE BACKUP — older themes preserved per Kim May 15 2026
// ocean: { label:'Ocean', bodyBg:'#F0F6FA', cardBg:'#FFFFFF', text:'#1B3A4D', subtext:'#6B8596',
//   colors: { coral:{bg:'#DAE8F0',border:'#1B6E8E',dark:'#0B3040',main:'#1B6E8E'}, teal:{bg:'#E0E6F0',border:'#3D5E8E',dark:'#1A2D44',main:'#3D5E8E'}, gold:{bg:'#DFECE6',border:'#3D8E7A',dark:'#1A3E33',main:'#3D8E7A'}, plum:{bg:'#F3EDDA',border:'#C4A86A',dark:'#5E4A1F',main:'#C4A86A'} },
//   habits:['#1B6E8E','#3D5E8E','#3D8E7A','#C4A86A','#4F9FC4','#8AB8A0'] }
// linen: { label:'Linen', bodyBg:'#FAF8F4', cardBg:'#FFFFFF', text:'#3D3D3D', subtext:'#7A7570',
//   colors: { coral:{bg:'#EDEDED',border:'#3D3D3D',dark:'#1F1F1F',main:'#3D3D3D'}, teal:{bg:'#F2E5E9',border:'#B87A8A',dark:'#5A2F3A',main:'#B87A8A'}, gold:{bg:'#E5EDE5',border:'#6A8A6A',dark:'#2D3E2D',main:'#6A8A6A'}, plum:{bg:'#EFEAE3',border:'#8A7A6A',dark:'#3E3428',main:'#8A7A6A'} },
//   habits:['#3D3D3D','#B87A8A','#6A8A6A','#8A7A6A','#6B6B6B','#A8949B'] }
// midnight: { label:'Midnight', bodyBg:'#0F1A2E', cardBg:'#1A2A4A', text:'#F0F0F5', subtext:'#8A95AB',
//   colors: { coral:{bg:'#1A2A4A',border:'#1A2A4A',dark:'#C4D4EE',main:'#6A85B8'}, teal:{bg:'#2A1A3A',border:'#5A2A6A',dark:'#E0B8EE',main:'#8A5AA0'}, gold:{bg:'#3A2E10',border:'#C4982A',dark:'#F5DA88',main:'#C4982A'}, plum:{bg:'#132F38',border:'#2A6A7A',dark:'#9AD4E0',main:'#2A6A7A'} },
//   habits:['#6A85B8','#8A5AA0','#C4982A','#2A6A7A','#5AA0D4','#B88ACC'] }